import {
  defineMessages,
  MessageDescriptor
} from 'react-intl';

export enum LANGUAGE_KEY {
  ACTION = 'ACTION',
  ACTIONS = 'ACTIONS',
  ACTIONS_RESULTS_MESSAGE = 'ACTIONS_RESULTS_MESSAGE',
  ADD = 'ADD',
  COURSE_SECTION = 'COURSE_SECTION',
  ADD_A_FOLDER = 'ADD_A_FOLDER',
  ADD_A_RESOURCE = 'ADD_A_RESOURCE',
  ATTEMPT_LIMIT = 'ATTEMPT_LIMIT',
  ATTEMPT_LIMIT_TOOLTIP_LABEL = 'ATTEMPT_LIMIT_TOOLTIP_LABEL',
  ATTEMPT_LIMIT_TOOLTIP_MESSAGE = 'ATTEMPT_LIMIT_TOOLTIP_MESSAGE',
  ATTEMPT_LIMIT_TOOLTIP_MESSAGE_BOLD_WORD = 'ATTEMPT_LIMIT_TOOLTIP_MESSAGE_BOLD_WORD',
  ADD_DATE_RANGE_TO_EACH_UNIT = 'ADD_DATE_RANGE_TO_EACH_UNIT',
  ADD_RESOURCES = 'ADD_RESOURCES',
  ADD_MORE_RESOURCES = 'ADD_MORE_RESOURCES',
  ADD_SINGLE_RESOURCE = 'ADD_SINGLE_RESOURCE',
  ADDITIONAL_LESSONS_COMING_SOON = 'ADDITIONAL_LESSONS_COMING_SOON',
  ADD_EDIT_DATE_RANGE = 'ADD_EDIT_DATE_RANGE',
  ALL_ATTEMPTS_TITLE = 'ALL_ATTEMPTS_TITLE',
  ALL_ITEMS = 'ALL_ITEMS',
  ALL_VIEWS = 'ALL_VIEWS',
  ALREADY_UNASSIGNED_SKIPPED = 'ALREADY_UNASSIGNED_SKIPPED',
  APPLICATION = 'APPLICATION',
  ARCHIVED_VERSION = 'ARCHIVED_VERSION',
  ARE_YOU_SURE = 'ARE_YOU_SURE',
  AREA = 'AREA',
  ASSIGNMENT_CAN_NOT_BE_UNASSIGNED = 'ASSIGNMENT_CAN_NOT_BE_UNASSIGNED',
  ASSIGNMENT_PERFORMANCE = 'ASSIGNMENT_PERFORMANCE',
  ASSIGNMENT_REPORT_TITLE = 'ASSIGNMENT_REPORT_TITLE',
  ASSIGNMENT_SUBMISSIONS_TITLE = 'ASSIGNMENT_SUBMISSIONS_TITLE',
  ASSIGNMENT_TYPE_DOES_NOT_SUPPORT_PASS_FAIL_GRADING = 'ASSIGNMENT_TYPE_DOES_NOT_SUPPORT_PASS_FAIL_GRADING',
  ASSIGNMENT_TYPE_DOES_NOT_SUPPORT_SCORE_GRADING = 'ASSIGNMENT_TYPE_DOES_NOT_SUPPORT_SCORE_GRADING',
  ATTEMPT = 'ATTEMPT',
  ATTEMPTS_ALLOWED = 'ATTEMPTS_ALLOWED',
  AUTHESS_MODAL_MESSAGE = 'AUTHESS_MODAL_MESSAGE',
  AUTOMATICALLY_ADD_AND_DISTRIBUTE_CONTENT_ACROSS_WEEKS = 'AUTOMATICALLY_ADD_AND_DISTRIBUTE_CONTENT_ACROSS_WEEKS',
  AVERAGE_ACTION_SCORE_ON_BEST_ATTEMPT = 'AVERAGE_ACTION_SCORE_ON_BEST_ATTEMPT',
  AVERAGE_QUESTION_PERFORMANCE = 'AVERAGE_QUESTION_PERFORMANCE',
  AVERAGE_QUESTIONS_MESSAGE = 'AVERAGE_QUESTIONS_MESSAGE',
  AVERAGE_SCORE = 'AVERAGE_SCORE',
  BATCH_ACTION_BAR_EDIT_CLOSE = 'BATCH_ACTION_BAR_EDIT_CLOSE',
  BATCH_ACTION_BAR_EDIT_DATES_NO_ITEMS_SELECTED = 'BATCH_ACTION_BAR_EDIT_DATES_NO_ITEMS_SELECTED',
  BATCH_ACTIONS_BAR_DESELECT_ALL = 'BATCH_ACTIONS_BAR_DESELECT_ALL',
  BATCH_ACTIONS_BAR_EDIT_DATES = 'BATCH_ACTIONS_BAR_EDIT_DATES',
  BATCH_ACTIONS_BAR_MAKE_VISIBLE_NOW = 'BATCH_ACTIONS_BAR_MAKE_VISIBLE_NOW',
  BATCH_ACTIONS_BAR_MOVE_REORDER = 'BATCH_ACTIONS_BAR_MOVE_REORDER',
  BATCH_ACTIONS_BAR_REMOVE = 'BATCH_ACTIONS_BAR_REMOVE',
  BATCH_ACTIONS_BAR_SELECT_ALL = 'BATCH_ACTIONS_BAR_SELECT_ALL',
  BATCH_ACTIONS_BAR_UNASSIGN = 'BATCH_ACTIONS_BAR_UNASSIGN',
  BOOK_SECTION = 'BOOK_SECTION',
  BULK_ADD = 'BULK_ADD',
  BULK_EDIT_SETTINGS_PAGE_AVAILABLE_FROM_COL = 'BULK_EDIT_SETTINGS_PAGE_AVAILABLE_FROM_COL',
  BULK_EDIT_SETTINGS_PAGE_BY_DAYS = 'BULK_EDIT_SETTINGS_PAGE_BY_DAYS',
  BULK_EDIT_SETTINGS_PAGE_BY_HOURS = 'BULK_EDIT_SETTINGS_PAGE_BY_HOURS',
  BULK_EDIT_SETTINGS_PAGE_BY_MINUTES = 'BULK_EDIT_SETTINGS_PAGE_BY_MINUTES',
  BULK_EDIT_SETTINGS_PAGE_BY_WEEKS = 'BULK_EDIT_SETTINGS_PAGE_BY_WEEKS',
  BULK_EDIT_SETTINGS_PAGE_CANCEL_BTN = 'BULK_EDIT_SETTINGS_PAGE_CANCEL_BTN',
  BULK_EDIT_SETTINGS_PAGE_CHANGE_ALL_DATES_TAB = 'BULK_EDIT_SETTINGS_PAGE_CHANGE_ALL_DATES_TAB',
  BULK_EDIT_SETTINGS_PAGE_DUE_COL = 'BULK_EDIT_SETTINGS_PAGE_DUE_COL',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_GRADING_STARTED_ASSIGNMENT_WARNING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_GRADING_STARTED_ASSIGNMENT_WARNING',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_GRADE_POINTS_STARTED_ASSIGNMENT_WARNING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_GRADE_POINTS_STARTED_ASSIGNMENT_WARNING',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_NOT_GRADED_GRADE_POINTS_WARNING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_NOT_GRADED_GRADE_POINTS_WARNING',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_AVAILABLE_DATE = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_AVAILABLE_DATE',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_AVAILABLE_DATE_NO_DATE = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_AVAILABLE_DATE_NO_DATE',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_DUE_DATE = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_DUE_DATE',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_DUE_DATE_NO_DATE = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_DUE_DATE_NO_DATE',
  // eslint-disable-next-line max-len
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_GRADING_STARTED_ASSIGNMENT_WARNING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_GRADING_STARTED_ASSIGNMENT_WARNING',
  // eslint-disable-next-line max-len
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_GRADE_POINTS_STARTED_ASSIGNMENT_WARNING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_GRADE_POINTS_STARTED_ASSIGNMENT_WARNING',
  APPLY_TO_ALL = 'APPLY_TO_ALL',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_HEADING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_HEADING',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_AVAILABLE_DATE = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_AVAILABLE_DATE',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_DUE_DATE = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_DUE_DATE',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_GRADING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_GRADING',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_UNPUBLISHED_LESSON_WARNING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_UNPUBLISHED_LESSON_WARNING',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_UNPUBLISHED_LESSON_SKIPPED_WARNING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_UNPUBLISHED_LESSON_SKIPPED_WARNING',
  BULK_EDIT_SETTINGS_PAGE_EXTEND_ALL_DATES_TAB = 'BULK_EDIT_SETTINGS_PAGE_EXTEND_ALL_DATES_TAB',
  BULK_EDIT_SETTINGS_PAGE_GRADE_TYPE_UNCHANGED_MODAL = 'BULK_EDIT_SETTINGS_PAGE_GRADE_TYPE_UNCHANGED_MODAL',
  BULK_EDIT_SETTINGS_PAGE_GRADE_POINTS_APPLY_TO_ALL_UNSUPPORTED_WARNING = 'BULK_EDIT_SETTINGS_PAGE_GRADE_POINTS_APPLY_TO_ALL_UNSUPPORTED_WARNING',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_UNSUPPORTED_ITEM_GRADE_POINTS_WARNING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_UNSUPPORTED_ITEM_GRADE_POINTS_WARNING',
  BULK_EDIT_SETTINGS_PAGE_DUE_DATE_MODAL_DESCRIPTION = 'BULK_EDIT_SETTINGS_PAGE_DUE_DATE_MODAL_DESCRIPTION',
  BULK_EDIT_SETTINGS_PAGE_GRADING_MODAL_DESCRIPTION = 'BULK_EDIT_SETTINGS_PAGE_GRADING_MODAL_DESCRIPTION',
  BULK_EDIT_SETTINGS_PAGE_GRADE_POINTS_MODAL_DESCRIPTION = 'BULK_EDIT_SETTINGS_PAGE_GRADE_POINTS_MODAL_DESCRIPTION',
  BULK_EDIT_SETTINGS_PAGE_HEADER = 'BULK_EDIT_SETTINGS_PAGE_HEADER',
  BULK_EDIT_SETTINGS_PAGE_INCLUDE_AVAILABLE_COL = 'BULK_EDIT_SETTINGS_PAGE_INCLUDE_AVAILABLE_COL',
  BULK_EDIT_SETTINGS_PAGE_INCLUDE_DUE_COL = 'BULK_EDIT_SETTINGS_PAGE_INCLUDE_DUE_COL',
  BULK_EDIT_SETTINGS_PAGE_PUSH_AVAILABILITY_DATES = 'BULK_EDIT_SETTINGS_PAGE_PUSH_AVAILABILITY_DATES',
  BULK_EDIT_SETTINGS_PAGE_PUSH_DUE_DATES = 'BULK_EDIT_SETTINGS_PAGE_PUSH_DUE_DATES',
  BULK_EDIT_SETTINGS_PAGE_RESOURCE_NAME_COL = 'BULK_EDIT_SETTINGS_PAGE_RESOURCE_NAME_COL',
  BULK_EDIT_SETTINGS_PAGE_RESOURCE_TYPE_COL = 'BULK_EDIT_SETTINGS_PAGE_RESOURCE_TYPE_COL',
  BULK_EDIT_SETTINGS_PAGE_SHIFT_DATES_TAB = 'BULK_EDIT_SETTINGS_PAGE_SHIFT_DATES_TAB',
  BULK_EDIT_SETTINGS_PAGE_SUBMIT_BTN = 'BULK_EDIT_SETTINGS_PAGE_SUBMIT_BTN',
  BULK_EDIT_SETTINGS_SUBMIT_TOAST_ERROR = 'BULK_EDIT_SETTINGS_SUBMIT_TOAST_ERROR',
  BULK_EDIT_SETTINGS_TEACHING_RESOURCE_WARNING = 'BULK_EDIT_SETTINGS_TEACHING_RESOURCE_WARNING',
  BULK_SELECT = 'BULK_SELECT',
  BUILD_COURSE_WITH_DESIRED_CONTENT = 'BUILD_COURSE_WITH_DESIRED_CONTENT',
  BUTTON_ADD = 'BUTTON_ADD',
  BUTTON_ADD_A_FOLDER = 'BUTTON_ADD_A_FOLDER',
  BUTTON_ADD_MORE_RESOURCES = 'BUTTON_ADD_MORE_RESOURCES',
  CONFIRM = 'CONFIRM',
  CANCEL = 'CANCEL',
  CANCEL_AND_RETURN_TO_PREVIOUS_PAGE = 'CANCEL_AND_RETURN_TO_PREVIOUS_PAGE',
  CANNOT_BE_UNASSIGNED = 'CANNOT_BE_UNASSIGNED',
  CASE_STUDY = 'CASE_STUDY',
  CATALOG = 'CATALOG',
  CATALOG_ADD_CONFIRM_MESSAGE = 'CATALOG_ADD_CONFIRM_MESSAGE',
  CATALOG_ITEM_STATUS = 'CATALOG_ITEM_STATUS',
  CATALOG_ITEM_STATUS_VIEW_LESS_BTN = 'CATALOG_ITEM_STATUS_VIEW_LESS_BTN',
  CATALOG_ITEM_STATUS_VIEW_MORE_BTN = 'CATALOG_ITEM_STATUS_VIEW_MORE_BTN',
  CHANGE_COURSE = 'CHANGE_COURSE',
  CLASS_AVERAGE_ON_ALL_SUBMISSIONS = 'CLASS_AVERAGE_ON_ALL_SUBMISSIONS',
  CLASS_AVERAGE_ON_VIDEO_COMPLETION_FOR_ALL_VIEWS = 'CLASS_AVERAGE_ON_VIDEO_COMPLETION_FOR_ALL_VIEWS',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  CLEAR_SEARCH = 'CLEAR_SEARCH',
  CLICK_HERE = 'CLICK_HERE',
  COLLAPSE_ALL_FOLDERS = 'COLLAPSE_ALL_FOLDERS',
  COMING_SOON = 'COMING_SOON',
  COMPLETE_STUDENTS_TITLE = 'COMPLETE_STUDENTS_TITLE',
  COMPLETED = 'COMPLETED',
  COMPLETED_STUDENTS = 'COMPLETED_STUDENTS',
  CONFIRM_ACTION_ON_HIDDEN_SYLLABUS = 'CONFIRM_ACTION_ON_HIDDEN_SYLLABUS',
  CONFIRM_SELECTED_ITEMS = 'CONFIRM_SELECTED_ITEMS',
  CONFIRM_UNASSIGN_MODAL = 'CONFIRM_UNASSIGN_MODAL',
  COPY_COURSE_HAS_CONTENT_MESSAGE = 'COPY_COURSE_HAS_CONTENT_MESSAGE',
  COPY_COURSE_NO_CONTENT_MESSAGE = 'COPY_COURSE_NO_CONTENT_MESSAGE',
  COPY_COURSE_REMINDER_MESSAGE_PART_1A = 'COPY_COURSE_REMINDER_MESSAGE_PART_1A',
  COPY_COURSE_REMINDER_MESSAGE_PART_2A = 'COPY_COURSE_REMINDER_MESSAGE_PART_2A',
  COPY_COURSE_REMINDER_MESSAGE_PART_3A = 'COPY_COURSE_REMINDER_MESSAGE_PART_3A',
  COURSE_BUILDER_PREVIEW_DEFAULT_MESSAGE = 'COURSE_BUILDER_PREVIEW_DEFAULT_MESSAGE',
  COURSE_BUILDER_WHICH_CONTENT_TYPES = 'COURSE_BUILDER_WHICH_CONTENT_TYPES',
  COURSE_COPY_UNMAPPED_ITEMS_TITLE = 'COURSE_COPY_UNMAPPED_ITEMS_TITLE',
  COURSE_MIGRATE_UNMAPPED_ITEMS_TITLE = 'COURSE_MIGRATE_UNMAPPED_ITEMS_TITLE',
  COURSE_COPY_WARN_MSG_PART_1A = 'COURSE_COPY_WARN_MSG_PART_1A',
  COURSE_COPY_WARN_MSG_PART_2A = 'COURSE_COPY_WARN_MSG_PART_2A',
  COURSE_COPY_WARN_MSG_PART_2B = 'COURSE_COPY_WARN_MSG_PART_2B',
  COURSE_MIGRATE_WARN_MSG_PART_1A = 'COURSE_MIGRATE_WARN_MSG_PART_1A',
  COURSE_MIGRATE_WARN_MSG_PART_2A = 'COURSE_MIGRATE_WARN_MSG_PART_2A',
  COURSE_END_DATE = 'COURSE_END_DATE',
  COURSE_LOCKED_NOTIFICATION = 'COURSE_LOCKED_NOTIFICATION',
  COURSE_NAME = 'COURSE_NAME',
  COURSE_OWNER_LOCKED_NOTIFICATION = 'COURSE_OWNER_LOCKED_NOTIFICATION',
  COURSE_START_DATE = 'COURSE_START_DATE',
  CREATE_YOUR_COURSE = 'CREATE_YOUR_COURSE',
  DATE_CREATED = 'DATE_CREATED',
  DEFAULT_TAB = 'DEFAULT_TAB',
  DISPLAY_DATE_FOR_EACH_UNIT = 'DISPLAY_DATE_FOR_EACH_UNIT',
  DISPLAY_DATES_TO_FOLDER = 'DISPLAY_DATES_TO_FOLDER',
  DISMISS = 'DISMISS',
  DISMISS_ALL = 'DISMISS_ALL',
  DO_NOT_ADD_CONTENT_MANUALLY_BUILD_COURSE = 'DO_NOT_ADD_CONTENT_MANUALLY_BUILD_COURSE',
  DRAG_DROP_TOGGLE = 'DRAG_DROP_TOGGLE',
  DUE_BY = 'DUE_BY',
  DUE_DATE = 'DUE_DATE',
  DUE_DATE_BEFORE_AVAILABLE_DATE_ERROR_MESSAGE = 'DUE_DATE_BEFORE_AVAILABLE_DATE_ERROR_MESSAGE',
  DUE_DATE_IS_REQUIRED_FOR_ALL_EAQ_ASSIGNMENTS = 'DUE_DATE_IS_REQUIRED_FOR_ALL_EAQ_ASSIGNMENTS',
  DUE_DATE_RESULTS_MESSAGE = 'DUE_DATE_RESULTS_MESSAGE',
  DUE_DATE_RESULTS_MESSAGE_SIMULATION_LINE1 = 'DUE_DATE_RESULTS_MESSAGE_SIMULATION_LINE1',
  DUE_DATE_RESULTS_MESSAGE_SIMULATION_LINE2 = 'DUE_DATE_RESULTS_MESSAGE_SIMULATION_LINE2',
  DUE_ON_DATE_AT_TIME = 'DUE_ON_DATE_AT_TIME',
  DURATION = 'DURATION',
  E_G_PATIENT_CARE = 'E_G_PATIENT_CARE',
  E_G_NAME = 'E_G_NAME',
  E_G_SHERPATH_FOR_FUNDAMENTALS = 'E_G_SHERPATH_FOR_FUNDAMENTALS',
  EDIT_LESSON_CONTENT = 'EDIT_LESSON_CONTENT',
  EDIT_SETTINGS_NO_ITEMS_SELECTED = 'EDIT_SETTINGS_NO_ITEMS_SELECTED',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  ROLE = 'ROLE',
  EMAIL = 'EMAIL',
  ENTER_A_NUMBER = 'ENTER_A_NUMBER',
  ENTER_PAGE_NUMBER_AND_OR_PAGE_RANGES_SEPARATED_BY_COMMAS = 'ENTER_PAGE_NUMBER_AND_OR_PAGE_RANGES_SEPARATED_BY_COMMAS',
  EXPAND_ALL_FOLDERS = 'EXPAND_ALL_FOLDERS',
  FAIL = 'FAIL',
  FILL_OUT_THE_FORM_BELOW_TO_BUILD_YOUR_COURSE = 'FILL_OUT_THE_FORM_BELOW_TO_BUILD_YOUR_COURSE',
  FILTER_BY = 'FILTER_BY',
  FILTER_BY_APPLICATION = 'FILTER_BY_APPLICATION',
  FILTER_BY_STATUS = 'FILTER_BY_STATUS',
  FILTER_CONTENT_BY = 'FILTER_CONTENT_BY',
  FILTERS_ARE_ON = 'FILTERS_ARE_ON',
  FOLDER_EDIT_MESSAGE = 'FOLDER_EDIT_MESSAGE',
  FIRST_FOLDER_TITLE = 'FIRST_FOLDER_TITLE',
  FOLDER_TITLE = 'FOLDER_TITLE',
  FOLDER_START_DATE = 'FOLDER_START_DATE',
  FOLDER_END_DATE = 'FOLDER_END_DATE',
  GRADE = 'GRADE',
  GRADE_TYPE = 'GRADE_TYPE',
  GRADING = 'GRADING',
  GRADING_PERFORMANCE_PAGE = 'GRADING_PERFORMANCE_PAGE',
  GRADE_TYPE_CANNOT_BE_CHANGED_ON_STARTED_ASSIGNMENT = 'GRADE_TYPE_CANNOT_BE_CHANGED_ON_STARTED_ASSIGNMENT',
  GRADE_TYPE_AND_GRADE_POINTS_CANNOT_BE_CHANGED_ON_STARTED_ASSIGNMENT = 'GRADE_TYPE_AND_GRADE_POINTS_CANNOT_BE_CHANGED_ON_STARTED_ASSIGNMENT',
  GROUP_ACTIVITY_TITLE = 'GROUP_ACTIVITY_TITLE',
  HESI_FILTER_TOOLTIP = 'HESI_FILTER_TOOLTIP',
  HESI_FOCUS_CHAPTERS = 'HESI_FOCUS_CHAPTERS',
  HOW_DO_YOU_ORGANIZE_YOUR_SYLLABUS = 'HOW_DO_YOU_ORGANIZE_YOUR_SYLLABUS',
  HOW_MANY_UNIT_DO_YOU_NEED = 'HOW_MANY_UNIT_DO_YOU_NEED',
  ICON_NO_PAST_ASSIGNMENTS = 'ICON_NO_PAST_ASSIGNMENTS',
  ICON_NO_UPCOMING_ASSIGNMENTS = 'ICON_NO_UPCOMING_ASSIGNMENTS',
  IMAGE_GALLERY_FETCH_ERROR = 'IMAGE_GALLERY_FETCH_ERROR',
  IMAGE_GALLERY_NO_IMAGES_AVAILABLE = 'IMAGE_GALLERY_NO_IMAGES_AVAILABLE',
  IMAGE_GALLERY_TITLE = 'IMAGE_GALLERY_TITLE',
  // eslint-disable-next-line max-len
  IN_ORDER_TO_GET_STARTED_PLEASE_SELECT_HOW_YOU_WOULD_LIKE_TO_ORGANIZE_YOUR_COURSE_RESOURCE = 'IN_ORDER_TO_GET_STARTED_PLEASE_SELECT_HOW_YOU_WOULD_LIKE_TO_ORGANIZE_YOUR_COURSE_RESOURCE',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_PROGRESS_OR_COMPLETED_GRADED_SKIPPED = 'IN_PROGRESS_OR_COMPLETED_GRADED_SKIPPED',
  INCOMPLETE_STUDENTS_TITLE = 'INCOMPLETE_STUDENTS_TITLE',
  INDICATES_REQUIRED_FIELD = 'INDICATES_REQUIRED_FIELD',
  INFORMATION_TOOLTIP = 'INFORMATION_TOOLTIP',
  INVALID_GRADE_POINTS = 'INVALID_GRADE_POINTS',
  INVALID_PAGE_RANGE_ERROR = 'INVALID_PAGE_RANGE_ERROR',
  LAST_DATE_WATCHED = 'LAST_DATE_WATCHED',
  LATEST_DATE_WATCHED = 'LATEST_DATE_WATCHED',
  LATE = 'LATE',
  LIMITED = 'LIMITED',
  LATEST_ATTEMPT_SCORE_TITLE = 'LATEST_ATTEMPT_SCORE_TITLE',
  LATEST_SUBMISSION_TIME = 'LATEST_SUBMISSION_TIME',
  LEARNING_DURATION = 'LEARNING_DURATION',
  LESSON_EDITOR_ASSESSMENT_QUESTIONS_HEADING = 'LESSON_EDITOR_ASSESSMENT_QUESTIONS_HEADING',
  LESSON_EDITOR_ASSESSMENT_QUESTIONS_INSTRUCTION = 'LESSON_EDITOR_ASSESSMENT_QUESTIONS_INSTRUCTION',
  LESSON_EDITOR_ASSIGNMENT_DETAILS = 'LESSON_EDITOR_ASSIGNMENT_DETAILS',
  LESSON_EDITOR_BLANK_LABEL = 'LESSON_EDITOR_BLANK_LABEL',
  LESSON_EDITOR_CONTENT_LOAD_ERROR = 'LESSON_EDITOR_CONTENT_LOAD_ERROR',
  LESSON_EDITOR_CONTENT_LOAD_RETRY = 'LESSON_EDITOR_CONTENT_LOAD_RETRY',
  LESSON_EDITOR_EDIT_ASSIGNMENT_DETAILS = 'LESSON_EDITOR_EDIT_ASSIGNMENT_DETAILS',
  LESSON_EDITOR_EDIT_CONTENT_TITLE = 'LESSON_EDITOR_EDIT_CONTENT_TITLE',
  LESSON_EDITOR_LESSON_TOPICS_HEADING = 'LESSON_EDITOR_LESSON_TOPICS_HEADING',
  LESSON_EDITOR_LESSON_TOPICS_INSTRUCTION = 'LESSON_EDITOR_LESSON_TOPICS_INSTRUCTION',
  LESSON_EDITOR_LOCKED_BANNER = 'LESSON_EDITOR_LOCKED_BANNER',
  LESSON_EDITOR_SELECT_AT_LEAST_ONE_QUESTION = 'LESSON_EDITOR_SELECT_AT_LEAST_ONE_QUESTION',
  LESSON_EDITOR_SELECT_AT_LEAST_ONE_TOPIC = 'LESSON_EDITOR_SELECT_AT_LEAST_ONE_TOPIC',
  LESSON_EDITOR_TOPIC_PREVIEW_BACK = 'LESSON_EDITOR_TOPIC_PREVIEW_BACK',
  LESSON_EDITOR_TOPIC_PREVIEW_LINK_HINT = 'LESSON_EDITOR_TOPIC_PREVIEW_LINK_HINT',
  LESSON_EDITOR_TOPIC_PREVIEW_LOAD_ERROR = 'LESSON_EDITOR_TOPIC_PREVIEW_LOAD_ERROR',
  LESSON_EDITOR_TOPIC_PREVIEW_TITLE = 'LESSON_EDITOR_TOPIC_PREVIEW_TITLE',
  LESSON_EDITOR_UNSAVED_CHANGES_BODY = 'LESSON_EDITOR_UNSAVED_CHANGES_BODY',
  LESSON_EDITOR_UNSAVED_CHANGES_CONTINUE_EDITING = 'LESSON_EDITOR_UNSAVED_CHANGES_CONTINUE_EDITING',
  LESSON_EDITOR_UNSAVED_CHANGES_DISCARD = 'LESSON_EDITOR_UNSAVED_CHANGES_DISCARD',
  LESSON_EDITOR_UNSAVED_CHANGES_TITLE = 'LESSON_EDITOR_UNSAVED_CHANGES_TITLE',
  LETS_BUILD_YOUR_COURSE = 'LETS_BUILD_YOUR_COURSE',
  LOCKED = 'LOCKED',
  LOCK_COPIED_COURSE = 'LOCK_COPIED_COURSE',
  MAKE_VISIBLE_NOW_NO_ITEMS_SELECTED = 'MAKE_VISIBLE_NOW_NO_ITEMS_SELECTED',
  MAKE_VISIBLE_NOW_SUCCESS_TOAST = 'MAKE_VISIBLE_NOW_SUCCESS_TOAST',
  MAKE_VISIBLE_NOW_ALREADY_AVAILABLE_WARNING_TOAST = 'MAKE_VISIBLE_NOW_ALREADY_AVAILABLE_WARNING_TOAST',
  MISSED_ACTIONS = 'MISSED_ACTIONS',
  MOVE_REORDER_ALL_ITEM_CANNOT_BE_SELECTED_TO_BE_MOVED_AT_ONCE = 'MOVE_REORDER_ALL_ITEM_CANNOT_BE_SELECTED_TO_BE_MOVED_AT_ONCE',
  MOVE_REORDER_NO_ITEMS_SELECTED = 'MOVE_REORDER_NO_ITEMS_SELECTED',
  MY_BOOKS = 'MY_BOOKS',
  MY_COURSES = 'MY_COURSES',
  NEW_CONTENT = 'NEW_CONTENT',
  NEW_LESSONS = 'NEW_LESSONS',
  NEW_LESSONS_ARE_AVAILABLE = 'NEW_LESSONS_ARE_AVAILABLE',
  NEW_LESSONS_AVAILABLE_NOW = 'NEW_LESSONS_AVAILABLE_NOW',
  NO_ASSIGNMENTS = 'NO_ASSIGNMENTS',
  NO_ASSIGNMENTS_STU = 'NO_ASSIGNMENTS_STU',
  NO_ASSIGNMENTS_WITHIN_DATE_RANGE = 'NO_ASSIGNMENTS_WITHIN_DATE_RANGE',
  NO_ASSIGNMENTS_TO_FILTER_IN_GIVEN_DATE_RANGE = 'NO_ASSIGNMENTS_TO_FILTER_IN_GIVEN_DATE_RANGE',
  NO_DUE_DATE = 'NO_DUE_DATE',
  NO_ENROLLMENTS = 'NO_ENROLLMENTS',
  NO_ITEM_TO_DISPLAY = 'NO_ITEM_TO_DISPLAY',
  NO_SUBMISSIONS = 'NO_SUBMISSIONS',
  NO_SUBMISSIONS_BEFORE_DUE_DATE = 'NO_SUBMISSIONS_BEFORE_DUE_DATE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  NOT_DUE = 'NOT_DUE',
  NOT_GRADED = 'NOT_GRADED',
  NOT_STARTED = 'NOT_STARTED',
  NOT_VISIBLE = 'NOT_VISIBLE',
  NUMBER_OF_ATTEMPTS = 'NUMBER_OF_ATTEMPTS',
  NUMBER_OF_ALLOWED_ATTEMPTS = 'NUMBER_OF_ALLOWED_ATTEMPTS',
  NUMBER_OF_ALLOWED_ATTEMPTS_LABEL = 'NUMBER_OF_ALLOWED_ATTEMPTS_LABEL',
  NUMBER_OF_ALLOWED_ATTEMPTS_MIN_ERROR = 'NUMBER_OF_ALLOWED_ATTEMPTS_MIN_ERROR',
  NUMBER_OF_ALLOWED_ATTEMPTS_MAX_ERROR = 'NUMBER_OF_ALLOWED_ATTEMPTS_MAX_ERROR',
  NUMBER_OF_STUDENTS_WITH_ASSIGNMENTS = 'NUMBER_OF_STUDENTS_WITH_ASSIGNMENTS',
  NUMBER_OF_UNITS = 'NUMBER_OF_UNITS',
  ORGANIZE_COURSE_BY = 'ORGANIZE_COURSE_BY',
  ONLY_FOLDERS_CAN_BE_DRAGGED_TO_THE_ROOT_LEVEL = 'ONLY_FOLDERS_CAN_BE_DRAGGED_TO_THE_ROOT_LEVEL',
  OPEN_COURSE_SETUP = 'OPEN_COURSE_SETUP',
  OPEN_EBOOK = 'OPEN_EBOOK',
  OR_A_FOLDER = 'OR_A_FOLDER',
  OSMOSIS_PILOT_SURVEY_PROMPT = 'OSMOSIS_PILOT_SURVEY_PROMPT',
  OVERVIEW = 'OVERVIEW',
  PAGE_TITLE = 'PAGE_TITLE',
  PASS = 'PASS',
  PASS_FAIL = 'PASS_FAIL',
  PAST_ASSIGNMENTS = 'PAST_ASSIGNMENTS',
  PAST_DUE_ASSIGNMENTS = 'PAST_DUE_ASSIGNMENTS',
  PLACE_CONTENT_INTO_PRODUCT_SPECIFIC_FOLDERS_DISTRIBUTE_ACROSS_WEEKS = 'PLACE_CONTENT_INTO_PRODUCT_SPECIFIC_FOLDERS_DISTRIBUTE_ACROSS_WEEKS',
  PERCENT_OF_CLASS_PERFORMED_CORRECTLY = 'PERCENT_OF_CLASS_PERFORMED_CORRECTLY',
  PLEASE_NOTE_THAT_UNASSIGNING = 'PLEASE_NOTE_THAT_UNASSIGNING',
  PLEASE_NOTE_STUDENT_DETAILS = 'PLEASE_NOTE_STUDENT_DETAILS',
  PLEASE_SELECT_AT_LEAST_ONE_CHAPTER_AND_PAGE = 'PLEASE_SELECT_AT_LEAST_ONE_CHAPTER_AND_PAGE',
  PRODUCT = 'PRODUCT',
  PURCHASE_BINDER_READY_VERSION = 'PURCHASE_BINDER_READY_VERSION',
  PURCHASE_HARCOVER_VERSION = 'PURCHASE_HARCOVER_VERSION',
  PURCHASE_PAPERBACK_VERSION = 'PURCHASE_PAPERBACK_VERSION',
  PURCHASE_SPIRAL_BOUND_VERSION = 'PURCHASE_SPIRAL_BOUND_VERSION',
  QUESTION_PREVIEW_MODAL_TITLE = 'QUESTION_PREVIEW_MODAL_TITLE',
  QUESTION_PREVIEW_MODAL_TYPE = 'QUESTION_PREVIEW_MODAL_TYPE',
  READING_SELECTION = 'READING_SELECTION',
  RE_ATTEMPT_OPEN = 'RE_ATTEMPT_OPEN',
  RE_ATTEMPTS_OPEN = 'RE_ATTEMPTS_OPEN',
  REMOVE_NO_ITEMS_SELECTED = 'REMOVE_NO_ITEMS_SELECTED',
  REPORT_CONTENT_ERROR = 'REPORT_CONTENT_ERROR',
  RESET = 'RESET',
  RESOURCE_LIBRARY = 'RESOURCE_LIBRARY',
  RESOURCE_TYPE = 'RESOURCE_TYPE',
  RESULTS_FILTERED = 'RESULTS_FILTERED',
  SAVE_AND_COMPLETE = 'SAVE_AND_COMPLETE',
  SAVE_AND_CONTINUE_TO_ADVANCED_SETTINGS = 'SAVE_AND_CONTINUE_TO_ADVANCED_SETTINGS',
  SCORE = 'SCORE',
  SCORED = 'SCORED',
  SCORES = 'SCORES',
  SEARCH_BY_KEYWORD_CHAPTER_OR_RESOURCE_TYPE = 'SEARCH_BY_KEYWORD_CHAPTER_OR_RESOURCE_TYPE',
  SEARCH_BY_COURSE_NAME_PRODUCT_OR_ISBN = 'SEARCH_BY_COURSE_NAME_PRODUCT_OR_ISBN',
  SEARCH_BY_FIRST_NAME_LAST_NAME_OR_EMAIL_ADDRESS = 'SEARCH_BY_FIRST_NAME_LAST_NAME_OR_EMAIL_ADDRESS',
  SEARCH_COURSE_SECTION = 'SEARCH_COURSE_SECTION',
  SEARCH = 'SEARCH',
  FIND_A_RESOURCE = 'FIND_A_RESOURCE',
  SEARCH_FOR_A_STUDENT = 'SEARCH_FOR_A_STUDENT',
  SECTION = 'SECTION',
  SECTIONS = 'SECTIONS',
  SELECT_A_COURSE_TO_COPY = 'SELECT_A_COURSE_TO_COPY',
  SELECT_ALL = 'SELECT_ALL',
  SELECT_EXISTING_COURSE_REQUIRED_ERROR = 'SELECT_EXISTING_COURSE_REQUIRED_ERROR',
  SET_AS_DEAFULT_TAB = 'SET_AS_DEAFULT_TAB',
  SIM_ACTIONS_TOOLTIP = 'SIM_ACTIONS_TOOLTIP',
  SIMULATION = 'SIMULATION',
  SIMULATION_IS_LOADING = 'SIMULATION_IS_LOADING',
  SKILL = 'SKILL',
  SKILL_ATTEMPT_RESULT_CORRECT_TAB = 'SKILL_ATTEMPT_RESULT_CORRECT_TAB',
  SKILL_ATTEMPT_RESULT_HEADER = 'SKILL_ATTEMPT_RESULT_HEADER',
  SKILL_ATTEMPT_RESULT_INCORRECT_TAB = 'SKILL_ATTEMPT_RESULT_INCORRECT_TAB',
  START_A_SELF_STUDY_QUIZ = 'START_A_SELF_STUDY_QUIZ',
  START_YOUR_COURSE_BUILDING_BY_PROVIDING_A_NAME_FOR_YOUR_FIRST_FOLDER = 'START_YOUR_COURSE_BUILDING_BY_PROVIDING_A_NAME_FOR_YOUR_FIRST_FOLDER',
  STATUS = 'STATUS',
  STUDENT = 'STUDENT',
  STUDENT_ENGAGEMENT = 'STUDENT_ENGAGEMENT',
  STUDENT_SCORES_TITLE = 'STUDENT_SCORES_TITLE',
  STUDENTS_WATCHED_THIS_VIDEO = 'STUDENTS_WATCHED_THIS_VIDEO',
  SUBMISSION_ATTEMPTS_APPLY_SUCCESS = 'SUBMISSION_ATTEMPTS_APPLY_SUCCESS',
  SUBMISSION_ATTEMPTS_LABEL = 'SUBMISSION_ATTEMPTS_LABEL',
  SUBMISSION_ATTEMPTS_NOTE = 'SUBMISSION_ATTEMPTS_NOTE',
  SUBMISSION_ATTEMPTS_SKIPPED_WARNING = 'SUBMISSION_ATTEMPTS_SKIPPED_WARNING',
  SUBMISSION_ATTEMPTS_TITLE = 'SUBMISSION_ATTEMPTS_TITLE',
  SUBMISSION_TIME = 'SUBMISSION_TIME',
  SYSTEM_REQUIREMENT_NOTE = 'SYSTEM_REQUIREMENT_NOTE',
  THE_FOLDER_IS_EMPTY = 'THE_FOLDER_IS_EMPTY',
  THE_PAGE_NUMBERS_OUT_OF_SCOPE_ERROR = 'THE_PAGE_NUMBERS_OUT_OF_SCOPE_ERROR',
  THE_PREVIOUS_CHANGES_YOU_MADE_ON_COURSE_PLAN_AND_THE_ASIGNMENTS_WILL_NOT_BE_PRESERVED = 'THE_PREVIOUS_CHANGES_YOU_MADE_ON_COURSE_PLAN_AND_THE_ASIGNMENTS_WILL_NOT_BE_PRESERVED',
  THIS_COURSE_INCLUDES = 'THIS_COURSE_INCLUDES',
  THIS_COURSE_INCLUDES_THE_FOLLOWING_PRODUCTS = 'THIS_COURSE_INCLUDES_THE_FOLLOWING_PRODUCTS',
  THIS_LESSON_HAS_NOT_RELEASE_YET = 'THIS_LESSON_HAS_NOT_RELEASE_YET',
  THIS_TYPICALLY_MATCHES_YOUR_SYLLABUS_STRUCTURE = 'THIS_TYPICALLY_MATCHES_YOUR_SYLLABUS_STRUCTURE',
  TIME_SPENT = 'TIME_SPENT',
  TIME_SPENT_ON_LESSON_TOOLTIP = 'TIME_SPENT_ON_LESSON_TOOLTIP',
  TOTAL_TIME_SPENT = 'TOTAL_TIME_SPENT',
  TIME_SPENT_PERFORMANCE_PAGE = 'TIME_SPENT_PERFORMANCE_PAGE',
  TOAST_SUCCESS_ADD_SYLLABUS = 'TOAST_SUCCESS_ADD_SYLLABUS',
  TOAST_SUCCESS_MOVE_SYLLABUS = 'TOAST_SUCCESS_MOVE_SYLLABUS',
  TOAST_SUCCESS_UPDATE_ASSIGNMENTS = 'TOAST_SUCCESS_UPDATE_ASSIGNMENTS',
  TOAST_SUCCESS_UPDATE_SYLLABUS = 'TOAST_SUCCESS_UPDATE_SYLLABUS',
  TO_BE_UNASSIGNED = 'TO_BE_UNASSIGNED',
  TOPICS = 'TOPICS',
  UNABLE_TO_DROP_EXCEED_LIMIT = 'UNABLE_TO_DROP_EXCEED_LIMIT',
  UNABLE_TO_DROP_INTO_ITS_CHILDREN = 'UNABLE_TO_DROP_INTO_ITS_CHILDREN',
  UNABLE_TO_DROP_ITSELF = 'UNABLE_TO_DROP_ITSELF',
  UNABLE_TO_UNASSIGN_BECAUSE_ALREADY_UNASSIGNED = 'UNABLE_TO_UNASSIGN_BECAUSE_ALREADY_UNASSIGNED',
  UNABLE_TO_UNASSIGN_BECAUSE_GRADED_STARTED = 'UNABLE_TO_UNASSIGN_BECAUSE_GRADED_STARTED',
  UNASSIGN_NO_ITEMS_SELECTED = 'UNASSIGN_NO_ITEMS_SELECTED',
  UNLIMITED = 'UNLIMITED',
  UPCOMING_ASSIGNMENTS = 'UPCOMING_ASSIGNMENTS',
  UPCOMING_TAB_MESSAGE = 'UPCOMING_TAB_MESSAGE',
  UPCOMING_LESSONS = 'UPCOMING_LESSONS',
  UPCOMING_LESSONS_MODAL_MESSAGE = 'UPCOMING_LESSONS_MODAL_MESSAGE',
  VIEW = 'VIEW',
  VIEW_ALL_ATTEMPTS = 'VIEW_ALL_ATTEMPTS',
  VIEW_DETAILS = 'VIEW_DETAILS',
  VIEW_ATTEMPT_RESULTS = 'VIEW_ATTEMPT_RESULTS',
  VIEW_FULLSCREEN = 'VIEW_FULLSCREEN',
  VIEW_IMAGE_GALLERY = 'VIEW_IMAGE_GALLERY',
  VIEW_NEW_LESSONS = 'VIEW_NEW_LESSONS',
  VIEW_SYSTEM_REQUIREMENTS = 'VIEW_SYSTEM_REQUIREMENTS',
  VIEW_UPCOMING_LESSONS = 'VIEW_UPCOMING_LESSONS',
  VISIBLE_ON_DATE_AT_TIME = 'VISIBLE_ON_DATE_AT_TIME',
  VISIBLE_UPON_RELEASE = 'VISIBLE_UPON_RELEASE',
  VIDEO_COMPLETED_RESULTS_MESSAGE = 'VIDEO_COMPLETED_RESULTS_MESSAGE',
  VIDEO_COMPLETION = 'VIDEO_COMPLETION',
  VIDEO_COMPLETION_BASED_ON_LATEST_VIEW = 'VIDEO_COMPLETION_BASED_ON_LATEST_VIEW',
  ESTIMATED_TIME = 'ESTIMATED_TIME',
  WANT_TO_PROCEED = 'WANT_TO_PROCEED',
  WARNING_MESSAGE_FOR_REMOVE_WHEN_FILTERED = 'WARNING_MESSAGE_FOR_REMOVE_WHEN_FILTERED',
  // eslint-disable-next-line max-len
  WARNING_MESSAGE_FOR_UNABLE_TO_REMOVE_WHEN_ASSIGNMENT_STARTED = 'WARNING_MESSAGE_FOR_UNABLE_TO_REMOVE_WHEN_ASSIGNMENT_STARTED',
  WARNING_MESSAGE_FOR_UNASSIGN_WHEN_FILTER = 'WARNING_MESSAGE_FOR_UNASSIGN_WHEN_FILTER',
  WARNING_MESSAGE_FOR_UNASSIGN_WHEN_THERE_IS_A_SKIPPED_ITEM = 'WARNING_MESSAGE_FOR_UNASSIGN_WHEN_THERE_IS_A_SKIPPED_ITEM',
  WARNING_MESSAGE_FOR_UPCOMING_LESSON = 'WARNING_MESSAGE_FOR_UPCOMING_LESSON',
  WARNING_MESSAGE_FOR_ARCHIVED_ASSIGNMENT_INSTRUCTOR = 'WARNING_MESSAGE_FOR_ARCHIVED_ASSIGNMENT_INSTRUCTOR',
  WARNING_MESSAGE_FOR_ARCHIVED_ASSIGNMENT_STUDENT = 'WARNING_MESSAGE_FOR_ARCHIVED_ASSIGNMENT_STUDENT',
  WE_NEED_TO_KNOW_A_LITTLE_MORE_ABOUT_HOW_TO_STRUCTURE_YOUR_COURSE = 'WE_NEED_TO_KNOW_A_LITTLE_MORE_ABOUT_HOW_TO_STRUCTURE_YOUR_COURSE',
  WELCOME_TO_COURSE_BUILDER = 'WELCOME_TO_COURSE_BUILDER',
  WELCOME_TO_YOUR_COURSE = 'WELCOME_TO_YOUR_COURSE',
  WELCOME_USER = 'WELCOME_USER',
  WOULD_YOU_LIKE_US_TO_AUTOMATICALLY_ADD_CONTENT_TO_YOUR_COURSE = 'WOULD_YOU_LIKE_US_TO_AUTOMATICALLY_ADD_CONTENT_TO_YOUR_COURSE',
  YOU_CAN_ADD_REMOVE_MOVE_CONTENT_AFTER_YOUR_COURSE_IS_CREATED = 'YOU_CAN_ADD_REMOVE_MOVE_CONTENT_AFTER_YOUR_COURSE_IS_CREATED',
  YOUR_COURSE_PLAN_IS_EMPTY = 'YOUR_COURSE_PLAN_IS_EMPTY',
  YOUR_FILTERED_RESULT_IS_EMPTY = 'YOUR_FILTERED_RESULT_IS_EMPTY',
  ASSIGNMENT_CONTENT_ID_IS_EMPTY = 'ASSIGNMENT_CONTENT_ID_IS_EMPTY',
  ASSIGNMENT_TITLE_IS_EMPTY = 'ASSIGNMENT_TITLE_IS_EMPTY',
  INVALID_AVAILABILITY_DATE = 'INVALID_AVAILABILITY_DATE',
  INVALID_DUE_DATE = 'INVALID_DUE_DATE',
  ENTRY_EXCEEDS_LENGTH_LIMIT = 'ENTRY_EXCEEDS_LENGTH_LIMIT',
  VALUE_REQUIRED = 'VALUE_REQUIRED',
  COURSE_COPY_START_DATE_TOOLTIP = 'COURSE_COPY_START_DATE_TOOLTIP',
  COPY_URL = 'COPY_URL',
  COPY_DEEP_LINK_INSTRUCTIONS = 'COPY_DEEP_LINK_INSTRUCTIONS',
  COPY_DEEP_COPY_SUCCESS_TOAST = 'COPY_DEEP_COPY_SUCCESS_TOAST',
  CLOSE = 'CLOSE',
  DEEP_LINK_CREATE_WARNING_TOAST_LINE_1 = 'DEEP_LINK_CREATE_WARNING_TOAST_LINE_1',
  DEEP_LINK_CREATE_WARNING_TOAST_LINE_2 = 'DEEP_LINK_CREATE_WARNING_TOAST_LINE_2',
  INVALID_URL_FORMAT = 'INVALID_URL_FORMAT',
  INVALID_URL_PROTOCOL = 'INVALID_URL_PROTOCOL',
  OKAY = 'OKAY',
  TRANSCRIPT = 'TRANSCRIPT',
  TOGGLE_TRANSCRIPT = 'TOGGLE_TRANSCRIPT',
  GRADE_POINTS = 'GRADE_POINTS',
  GRADE_POINTS_PERFORMANCE_PAGE = 'GRADE_POINTS_PERFORMANCE_PAGE',
  INCLUDE = 'INCLUDE',
  INCLUDES = 'INCLUDES',
  EXTERNAL_LINK_TOOLTIP = 'EXTERNAL_LINK_TOOLTIP',
  EXTERNAL_LINK_URL_NOTE = 'EXTERNAL_LINK_URL_NOTE',
  LAUNCH_STUDENT_VIEW = 'LAUNCH_STUDENT_VIEW',
  STUDENT_LAUNCH_WARNING = 'STUDENT_LAUNCH_WARNING',
  ADD_MANAGE_EAB_BANK_AND_ASSESSMENT = 'ADD_MANAGE_EAB_BANK_AND_ASSESSMENT',
  ADD_MANAGE_EAB_TEST_BANK_AND_ASSESSMENT = 'ADD_MANAGE_EAB_TEST_BANK_AND_ASSESSMENT',
  UPDATE_NAME = 'UPDATE_NAME',
  UPDATE_NAME_DIRECTION = 'UPDATE_NAME_DIRECTION',
  UPDATE_NAME_DIRECTION_2 = 'UPDATE_NAME_DIRECTION_2',
  EVOLVE_ACCOUNT = 'EVOLVE_ACCOUNT',
  ADD_NEW_USER_CAPPED = 'ADD_NEW_USER_CAPPED',
  ADD_NEW_USER = 'ADD_NEW_USER',
  CHANGES_MADE = 'CHANGES_MADE',
  LMS_NOTE = 'LMS_NOTE',
  SUBMIT = 'SUBMIT',
  REMOVE = 'REMOVE',
  REMOVE_USER = 'REMOVE_USER',
  MAKE_SELECTED_RESOURCES_VISIBLE_NOW = 'MAKE_SELECTED_RESOURCES_VISIBLE_NOW',
  MAKE_RESOURCES_VISIBLE_NOW = 'MAKE_RESOURCES_VISIBLE_NOW',
  CONTINUE_TO_COURSE_PLAN = 'CONTINUE_TO_COURSE_PLAN',
  CONTENT_RESOURCES_VISIBLE_MODAL_DESCRIPTION = 'CONTENT_RESOURCES_VISIBLE_MODAL_DESCRIPTION',
  MAKE_RESOURCES_VISIBLE = 'MAKE_RESOURCES_VISIBLE',
  PREVIEW_COURSE = 'PREVIEW_COURSE',
  UPDATE_PREVIEW = 'UPDATE_PREVIEW',
  UPDATE_PREVIEW_MESSAGE = 'UPDATE_PREVIEW_MESSAGE',
  CLICK_HERE_TO_ASSIGN_TO_COURSE_PLAN = 'CLICK_HERE_TO_ASSIGN_TO_COURSE_PLAN',
  SHADOW_HEALTH_BANNER_MSG = 'SHADOW_HEALTH_BANNER_MSG',
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_FROM_COURSE = 'ARE_YOU_SURE_YOU_WANT_TO_REMOVE_FROM_COURSE',
  REMOVED_FROM_COURSE = 'REMOVED_FROM_COURSE',
  UNABLE_TO_REMOVE_FROM_COURSE = 'UNABLE_TO_REMOVE_FROM_COURSE',
  ADDED_TO_COURSE = 'ADDED_TO_COURSE',
  UNABLE_TO_ADD_ITEM_ASSIGNMENT_CREATION_FAILED = 'UNABLE_TO_ADD_ITEM_ASSIGNMENT_CREATION_FAILED',
  UNABLE_TO_ADD_TO_COURSE = 'UNABLE_TO_ADD_TO_COURSE',
  NO_NUMBERS_SPACES_OR_SPECIAL_CHARS_ALLOWED = 'NO_NUMBERS_SPACES_OR_SPECIAL_CHARS_ALLOWED',
  INVALID_EMAIL_ADDRESS = 'INVALID_EMAIL_ADDRESS',
  ALREADY_ADDED_TO_COURSE = 'ALREADY_ADDED_TO_COURSE',
  IFRAME_WARNING = 'IFRAME_WARNING',
  IFRAME_WARNING_MSG_LINE_1 = 'IFRAME_WARNING_MSG_LINE_1',
  IFRAME_WARNING_MSG_LINE_2 = 'IFRAME_WARNING_MSG_LINE_2',
  SHOW_LIST_VIEW = 'SHOW_LIST_VIEW',
  SHOW_FOLDER_VIEW = 'SHOW_FOLDER_VIEW',
  RETURN_TO_PERFORMNCE_AND_GRADES = 'RETURN_TO_PERFORMNCE_AND_GRADES',
  EXAM_PREP_RESOURCES = 'EXAM_PREP_RESOURCES',
  SUBMIT_FEEDBACK = 'SUBMIT_FEEDBACK',
  ASK_SHERPATH_AI = 'ASK_SHERPATH_AI',
  SEND_SHERPATH_AI_A_PROMPT = 'SEND_SHERPATH_AI_A_PROMPT',
  PREVIEW = 'PREVIEW',
  BEGIN_QUIZ = 'BEGIN_QUIZ',
  RESUME_QUIZ = 'RESUME_QUIZ',
  START_NEW_QUIZ = 'START_NEW_QUIZ',
  INTERACTIVE_REVIEW_QUESTIONS = 'INTERACTIVE_REVIEW_QUESTIONS',
  RESULTS = 'RESULTS',
  ASSESSMENT_SCORE = 'ASSESSMENT_SCORE',
  ALL_DONE = 'ALL_DONE',
  ASSESSMENT_PERFORMANCE_CORRECT_TAB = 'ASSESSMENT_PERFORMANCE_CORRECT_TAB',
  ASSESSMENT_PERFORMANCE_INCORRECT_TAB = 'ASSESSMENT_PERFORMANCE_INCORRECT_TAB',
  RATIONALE = 'RATIONALE',
  ALL_COURSES_OVERVIEW = 'ALL_COURSES_OVERVIEW',
  ALL_COURSES_OVERVIEW_SUBHEADER = 'ALL_COURSES_OVERVIEW_SUBHEADER',
  NO_UPCOMING_ASSIGNMENTS_IN_THE_SELECTED_TIME_PERIOD = 'NO_UPCOMING_ASSIGNMENTS_IN_THE_SELECTED_TIME_PERIOD',
  BACK_TO_CURRENT_WEEK = 'BACK_TO_CURRENT_WEEK',
  BACK_TO_TOP = 'BACK_TO_TOP',
  APPLY = 'APPLY',
  FROM_DATE = 'FROM_DATE',
  TO_DATE = 'TO_DATE',
  TO_DATE_BEFORE_FROM_DATE_ERROR_MESSAGE = 'TO_DATE_BEFORE_FROM_DATE_ERROR_MESSAGE',
  BACK_ARROW_TOOLTIP = 'BACK_ARROW_TOOLTIP',
  FORWARD_ARROW_TOOLTIP = 'FORWARD_ARROW_TOOLTIP',
  AI_CHAT_PREVIEW_PLACEHOLDER = 'AI_CHAT_PREVIEW_PLACEHOLDER',
  ALL_COURSES_OVERVIEW_COURSE_FILTER_TOOL_TIP = 'ALL_COURSES_OVERVIEW_COURSE_FILTER_TOOL_TIP',
  HOW_WOULD_YOU_LIKE_YOUR_FOLDERS_TO_BE_SET_UP = 'HOW_WOULD_YOU_LIKE_YOUR_FOLDERS_TO_BE_SET_UP',
  VIEW_AS_STUDENT = 'VIEW_AS_STUDENT',
  EXIT_STUDENT_VIEW = 'EXIT_STUDENT_VIEW',
  VIEWING_AS_STUDENT_MESSAGE = 'VIEWING_AS_STUDENT_MESSAGE',
  CHOOSE_YOUR_COURSE_BUILDING_METHOD = 'CHOOSE_YOUR_COURSE_BUILDING_METHOD',
  CREATE_A_NEW_COURSE = 'CREATE_A_NEW_COURSE',
  CREATE_A_NEW_COURSE_DESCRIPTION = 'CREATE_A_NEW_COURSE_DESCRIPTION',
  COPY_AN_EXISTING_COURSE = 'COPY_AN_EXISTING_COURSE',
  COPY_AN_EXISTING_COURSE_DESCRIPTION = 'COPY_AN_EXISTING_COURSE_DESCRIPTION',
  COPY_A_COURSE = 'COPY_A_COURSE',
  CREATE_A_NEW_COURSE_WITH_AI = 'CREATE_A_NEW_COURSE_WITH_AI',
  UPLOAD_SYLLABUS = 'UPLOAD_SYLLABUS',
  AI_ENHANCED_COURSE_BUILDER = 'AI_ENHANCED_COURSE_BUILDER',
  ELSEVIERS_AI_ENHANCED_COURSE_BUILDER = 'ELSEVIERS_AI_ENHANCED_COURSE_BUILDER',
  UPLOAD_YOUR_SYLLABUS_HEAD_START = 'UPLOAD_YOUR_SYLLABUS_HEAD_START',
  ELSEVIER_DOES_NOT_SAVE = 'ELSEVIER_DOES_NOT_SAVE',
  DROP_YOUR_SYLLABUS = 'DROP_YOUR_SYLLABUS',
  CLICK_TO_BROWSE = 'CLICK_TO_BROWSE',
  MAX_FILE_SIZE = 'MAX_FILE_SIZE',
  SUPPORTS_PDF_DOCX = 'SUPPORTS_PDF_DOCX',
  SUCCESS_YOUR_SYLLABUS_HAS = 'SUCCESS_YOUR_SYLLABUS_HAS',
  PASTE = 'PASTE',
  PASTE_TEXT_FROM_SYLLABUS_DIRECTLY = 'PASTE_TEXT_FROM_SYLLABUS_DIRECTLY',
  PASTE_COURSE_DETAILS = 'PASTE_COURSE_DETAILS',
  PASTE_YOUR_COURSE_DETAILS = 'PASTE_YOUR_COURSE_DETAILS',
  PASTE_YOUR_SYLLABUS_HERE = 'PASTE_YOUR_SYLLABUS_HERE',
  PASTE_SYLLABUS_DESCRIPTION = 'PASTE_SYLLABUS_DESCRIPTION',
  COPY_AND_PASTE_SYLLABUS_TEXT = 'COPY_AND_PASTE_SYLLABUS_TEXT',
  SUBMIT_COURSE_DETAILS = 'SUBMIT_COURSE_DETAILS',
  SYLLABUS_CHARACTER_COUNT = 'SYLLABUS_CHARACTER_COUNT',
  SYLLABUS_CHARACTER_LIMIT_EXCEEDED = 'SYLLABUS_CHARACTER_LIMIT_EXCEEDED',
  SUCCESS_YOUR_SYLLABUS_RECEIVED = 'SUCCESS_YOUR_SYLLABUS_RECEIVED',
  SYLLABUS_TEXT_UPLOADED_TITLE = 'SYLLABUS_TEXT_UPLOADED_TITLE',
  SYLLABUS_TEXT_CONFIRMATION_DESCRIPTION = 'SYLLABUS_TEXT_CONFIRMATION_DESCRIPTION',
  SYLLABUS_FILE_CONFIRMATION_DESCRIPTION = 'SYLLABUS_FILE_CONFIRMATION_DESCRIPTION',
  SYLLABUS_TEXT_CONFIRMATION_PRODUCTS = 'SYLLABUS_TEXT_CONFIRMATION_PRODUCTS',
  SCANNING_YOUR_SYLLABUS_FOR_SECURITY = 'SCANNING_YOUR_SYLLABUS_FOR_SECURITY',
  SCANNING_YOUR_FILE_FOR_SECURITY = 'SCANNING_YOUR_FILE_FOR_SECURITY',
  REVIEWING_YOUR_SYLLABUS = 'REVIEWING_YOUR_SYLLABUS',
  EXTRACTING_YOUR_COURSE_STRUCTURE = 'EXTRACTING_YOUR_COURSE_STRUCTURE',
  MATCHING_RESOURCES_TO_YOUR_TOPICS = 'MATCHING_RESOURCES_TO_YOUR_TOPICS',
  PREPARING_YOUR_COURSE_PREVIEW = 'PREPARING_YOUR_COURSE_PREVIEW',
  YOUR_PROGRESS_WILL_BE_LOST = 'YOUR_PROGRESS_WILL_BE_LOST',
  PASTE_SYLLABUS_BACK_WARNING = 'PASTE_SYLLABUS_BACK_WARNING',
  PASTE_SYLLABUS_REFRESH_WARNING = 'PASTE_SYLLABUS_REFRESH_WARNING',
  I_UNDERSTAND = 'I_UNDERSTAND',
  AI_LOOK_FOR = 'AI_LOOK_FOR',
  COURSE_STRUCTURE_WEEKLY_TOPICS = 'COURSE_STRUCTURE_WEEKLY_TOPICS',
  STRUCTURE_WEEKLY_TOPICS = 'STRUCTURE_WEEKLY_TOPICS',
  LEARNING_OBJECTIVES_OUTCOMES = 'LEARNING_OBJECTIVES_OUTCOMES',
  ASSESSMENT_SCHEDULE_TYPES = 'ASSESSMENT_SCHEDULE_TYPES',
  REQUIRED_READINGS_RESOURCES = 'REQUIRED_READINGS_RESOURCES',
  CLINICAL_LAB_REQUIREMENTS = 'CLINICAL_LAB_REQUIREMENTS',
  NCLEX_QSEN_ALIGNMENT = 'NCLEX_QSEN_ALIGNMENT',
  OR = 'OR',
  DROP_FILE = 'DROP_FILE',
  SUCCESS_YOUR_FILE_HAS = 'SUCCESS_YOUR_FILE_HAS',
  SYLLABUS_CONFIRMATION_TITLE = 'SYLLABUS_CONFIRMATION_TITLE',
  SYLLABUS_BUILDING_TITLE = 'SYLLABUS_BUILDING_TITLE',
  YOUR_SYLLABUS = 'YOUR_SYLLABUS',
  REMOVE_FILE = 'REMOVE_FILE',
  REMOVE_SYLLABUS = 'REMOVE_SYLLABUS',
  SYLLABUS_ANALYSIS_FAILED_GENERIC = 'SYLLABUS_ANALYSIS_FAILED_GENERIC',
  CANNOT_CONNECT_ERROR = 'CANNOT_CONNECT_ERROR',
  FILE_REQUEST_ERROR = 'FILE_REQUEST_ERROR',
  PASTED_REQUEST_ERROR = 'PASTED_REQUEST_ERROR',
  BACK_AND_EDIT = 'BACK_AND_EDIT',
  VALIDATION_ERROR_TITLE = 'VALIDATION_ERROR_TITLE',
  VALIDATION_ISSUES = 'VALIDATION_ISSUES',
  VALIDATION_SUGGESTIONS = 'VALIDATION_SUGGESTIONS',
  PREVIEW_YOUR_COURSE = 'PREVIEW_YOUR_COURSE',
  CREATE_OR_EDIT_MESSAGING = 'CREATE_OR_EDIT_MESSAGING',
  EDIT_COURSE = 'EDIT_COURSE',
  CREATE_COURSE = 'CREATE_COURSE',
  BACK = 'BACK',
  NO_PREVIEW_AVAILABLE = 'NO_PREVIEW_AVAILABLE',
  PLEASE = 'PLEASE',
  EDIT_YOUR_COURSE = 'EDIT_YOUR_COURSE',
  EDIT_YOUR_COURSE_LC_PERIOD = 'EDIT_YOUR_COURSE_LC_PERIOD',
  USE_THE_FORM_BELOW = 'USE_THE_FORM_BELOW',
  UPON_SELECTING_UPDATE_COURSE = 'UPON_SELECTING_UPDATE_COURSE',
  UPDATE_COURSE = 'UPDATE_COURSE',
  BASED_ON_YOUR_SYLLABUS = 'BASED_ON_YOUR_SYLLABUS',
  HOW_DOES_IT_WORK = 'HOW_DOES_IT_WORK',
  ELSEVIERS_AI_ENHANCED = 'ELSEVIERS_AI_ENHANCED',
  UPLOAD_YOUR_SYLLABUS = 'UPLOAD_YOUR_SYLLABUS',
  THE_AI_BUILDS_A_COURSE_PREVIEW = 'THE_AI_BUILDS_A_COURSE_PREVIEW',
  GENERATE_A_COURSE_PREVIEW = 'GENERATE_A_COURSE_PREVIEW',
  REFINE_YOUR_COURSE = 'REFINE_YOUR_COURSE',
  THE_AI_BUILDS_AN_EDITABLE = 'THE_AI_BUILDS_AN_EDITABLE',
  YOUR_COURSE_IS_ADDED = 'YOUR_COURSE_IS_ADDED',
  UPLOAD_SYLLABUS_COURSE_CALENDAR = 'UPLOAD_SYLLABUS_COURSE_CALENDAR',
  RECORDED_ATTEMPT = 'RECORDED_ATTEMPT',
  FIRST = 'FIRST',
  LAST = 'LAST',
  BEST = 'BEST',
  EDITING_HERE_ALLOWS = 'EDITING_HERE_ALLOWS',
  RENAME_FOLDER = 'RENAME_FOLDER',
  SELECTED_FOLDER = 'SELECTED_FOLDER',
  FOLDER_NAME = 'FOLDER_NAME',
  SAVE_FOLDER_NAME = 'SAVE_FOLDER_NAME',
  REMOVE_FOLDER = 'REMOVE_FOLDER',
  REMOVE_ITEM = 'REMOVE_ITEM',
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE = 'ARE_YOU_SURE_YOU_WANT_TO_REMOVE',
  WARNING_ALL_CONTENT = 'WARNING_ALL_CONTENT',
  YES_REMOVE = 'YES_REMOVE',
  INCLUDES_COLON = 'INCLUDES_COLON',
  CONFIRM_AND_UPLOAD = 'CONFIRM_AND_UPLOAD',
  SYLLABUS_PREVIEW_CREATED_TITLE = 'SYLLABUS_PREVIEW_CREATED_TITLE',
  SYLLABUS_PREVIEW_CREATED_DESCRIPTION = 'SYLLABUS_PREVIEW_CREATED_DESCRIPTION',
  VIEW_COURSE_PREVIEW = 'VIEW_COURSE_PREVIEW',
  STUDENT_STUDY_YOUR_LEARNING = 'STUDENT_STUDY_YOUR_LEARNING',
  STUDENT_STUDY_QBANK = 'STUDENT_STUDY_QBANK',
  STUDENT_STUDY_CONCEPTS_TO_FOCUS_ON = 'STUDENT_STUDY_CONCEPTS_TO_FOCUS_ON',
  STUDENT_STUDY_CONCEPTS_TO_FOCUS_ON_SUBTITLE = 'STUDENT_STUDY_CONCEPTS_TO_FOCUS_ON_SUBTITLE',
  STUDENT_STUDY_FOCUS_AREAS = 'STUDENT_STUDY_FOCUS_AREAS',
  STUDENT_STUDY_FOCUS_AREAS_EMPTY_SUBTITLE = 'STUDENT_STUDY_FOCUS_AREAS_EMPTY_SUBTITLE',
  STUDENT_STUDY_CONCEPTS_TO_FOCUS_ON_FILLED_SUBTITLE = 'STUDENT_STUDY_CONCEPTS_TO_FOCUS_ON_FILLED_SUBTITLE',
  STUDENT_STUDY_CONCEPTS_TO_FOCUS_LOAD_ERROR = 'STUDENT_STUDY_CONCEPTS_TO_FOCUS_LOAD_ERROR',
  STUDENT_STUDY_LEARN = 'STUDENT_STUDY_LEARN',
  STUDENT_STUDY_QUIZ = 'STUDENT_STUDY_QUIZ',
  STUDENT_STUDY_TAKE_YOUR_FIRST_QUIZ = 'STUDENT_STUDY_TAKE_YOUR_FIRST_QUIZ',
  STUDENT_STUDY_MY_PROGRESS = 'STUDENT_STUDY_MY_PROGRESS',
  STUDENT_STUDY_OVERALL_COMPLETION = 'STUDENT_STUDY_OVERALL_COMPLETION',
  STUDENT_STUDY_LAST_QUIZ_ACTIVITY = 'STUDENT_STUDY_LAST_QUIZ_ACTIVITY',
  STUDENT_STUDY_NO_ACTIVITY_FOUND = 'STUDENT_STUDY_NO_ACTIVITY_FOUND',
  STUDENT_STUDY_QUIZ_HISTORY_EMPTY = 'STUDENT_STUDY_QUIZ_HISTORY_EMPTY',
  STUDENT_STUDY_USMLE_STUDY_GUIDE = 'STUDENT_STUDY_USMLE_STUDY_GUIDE',
  STUDENT_STUDY_USMLE_STUDY_GUIDE_SUBTITLE = 'STUDENT_STUDY_USMLE_STUDY_GUIDE_SUBTITLE',
  STUDENT_STUDY_SEARCH_PLACEHOLDER = 'STUDENT_STUDY_SEARCH_PLACEHOLDER',
  STUDENT_STUDY_CONTENT_OUTLINE_HEADER = 'STUDENT_STUDY_CONTENT_OUTLINE_HEADER',
  STUDENT_STUDY_PERCENT_CORRECT = 'STUDENT_STUDY_PERCENT_CORRECT',
  STUDY_TOPICS_SUBTITLE = 'STUDY_TOPICS_SUBTITLE',
  STUDY_TOPICS_QUESTIONS_ANSWERED = 'STUDY_TOPICS_QUESTIONS_ANSWERED',
  STUDY_TOPICS_SEARCH_PLACEHOLDER = 'STUDY_TOPICS_SEARCH_PLACEHOLDER',
  STUDY_TOPICS_NO_RESULTS = 'STUDY_TOPICS_NO_RESULTS',
  STUDY_TOPICS_LOAD_ERROR = 'STUDY_TOPICS_LOAD_ERROR',
  STUDENT_STUDY_LOAD_ERROR = 'STUDENT_STUDY_LOAD_ERROR',
  TEST_PREP_LOAD_ERROR = 'TEST_PREP_LOAD_ERROR',
  STUDENT_PERFORMANCE_LOAD_ERROR = 'STUDENT_PERFORMANCE_LOAD_ERROR',
  STUDENT_STUDY_PROGRESS_CORRECT = 'STUDENT_STUDY_PROGRESS_CORRECT',
  STUDENT_STUDY_PROGRESS_INCORRECT = 'STUDENT_STUDY_PROGRESS_INCORRECT',
  STUDENT_STUDY_PROGRESS_UNANSWERED = 'STUDENT_STUDY_PROGRESS_UNANSWERED',
  STUDENT_STUDY_PROGRESS_QUESTIONS_ANSWERED = 'STUDENT_STUDY_PROGRESS_QUESTIONS_ANSWERED',
  STUDENT_STUDY_PROGRESS_LOAD_ERROR = 'STUDENT_STUDY_PROGRESS_LOAD_ERROR',
  STUDENT_STUDY_RESUME = 'STUDENT_STUDY_RESUME',
  STUDENT_STUDY_REVIEW = 'STUDENT_STUDY_REVIEW',
  STUDENT_STUDY_SEE_ALL = 'STUDENT_STUDY_SEE_ALL',
  STUDENT_STUDY_UNTITLED_QUIZ = 'STUDENT_STUDY_UNTITLED_QUIZ',
  STUDENT_STUDY_QUESTIONS_ANSWERED = 'STUDENT_STUDY_QUESTIONS_ANSWERED',
  STUDENT_STUDY_QUIZ_ACTION_LABEL = 'STUDENT_STUDY_QUIZ_ACTION_LABEL',
  STUDENT_STUDY_LAST_QUIZ_LOAD_ERROR = 'STUDENT_STUDY_LAST_QUIZ_LOAD_ERROR',
  STUDENT_STUDY_OPEN_QUIZ_ERROR = 'STUDENT_STUDY_OPEN_QUIZ_ERROR',
  RESOURCE_DRAWER_QUESTIONS_ANSWERED = 'RESOURCE_DRAWER_QUESTIONS_ANSWERED',
  RESOURCE_DRAWER_QUESTIONS_CORRECT = 'RESOURCE_DRAWER_QUESTIONS_CORRECT',
  RESOURCE_DRAWER_QUESTIONS_ANSWERED_COUNT = 'RESOURCE_DRAWER_QUESTIONS_ANSWERED_COUNT',
  RESOURCE_DRAWER_LEARNING_RESOURCES_SUMMARY = 'RESOURCE_DRAWER_LEARNING_RESOURCES_SUMMARY',
  RESOURCE_DRAWER_QUIZ = 'RESOURCE_DRAWER_QUIZ',
  RESOURCE_DRAWER_NO_RESOURCES = 'RESOURCE_DRAWER_NO_RESOURCES',
  RESOURCE_DRAWER_LOAD_ERROR = 'RESOURCE_DRAWER_LOAD_ERROR',
  RESOURCE_DRAWER_ALSO_APPEARS_IN = 'RESOURCE_DRAWER_ALSO_APPEARS_IN',
  RESOURCE_DRAWER_CLOSE = 'RESOURCE_DRAWER_CLOSE',
  RESOURCE_DRAWER_OSMOSIS_VIDEO = 'RESOURCE_DRAWER_OSMOSIS_VIDEO',
  PERCENT_CORRECT = 'PERCENT_CORRECT',
  QUESTIONS_COMPLETE_COUNT = 'QUESTIONS_COMPLETE_COUNT',
  QUESTIONS_ANSWERED_COUNT = 'QUESTIONS_ANSWERED_COUNT',
}

const messages = Object.keys(LANGUAGE_KEY).reduce((acc, cur) => ({
  ...acc,
  [cur]: {
    id: cur,
    defaultMessage: cur,
  }
}), {}) as Record<LANGUAGE_KEY, MessageDescriptor>;

export const Translations = defineMessages<LANGUAGE_KEY>(messages);

// Define list of static messages that can be translated without passing any value in
export const StaticMessagesKeys: LANGUAGE_KEY[] = [
  LANGUAGE_KEY.ACTION,
  LANGUAGE_KEY.ACTIONS,
  LANGUAGE_KEY.ACTIONS_RESULTS_MESSAGE,
  LANGUAGE_KEY.ADD,
  LANGUAGE_KEY.ADD_A_FOLDER,
  LANGUAGE_KEY.ADD_A_RESOURCE,
  LANGUAGE_KEY.ADD_DATE_RANGE_TO_EACH_UNIT,
  LANGUAGE_KEY.ADD_RESOURCES,
  LANGUAGE_KEY.ADD_MORE_RESOURCES,
  LANGUAGE_KEY.ADD_SINGLE_RESOURCE,
  LANGUAGE_KEY.ADDITIONAL_LESSONS_COMING_SOON,
  LANGUAGE_KEY.ADD_EDIT_DATE_RANGE,
  LANGUAGE_KEY.ALL_ATTEMPTS_TITLE,
  LANGUAGE_KEY.ALL_ITEMS,
  LANGUAGE_KEY.ALL_VIEWS,
  LANGUAGE_KEY.ALREADY_UNASSIGNED_SKIPPED,
  LANGUAGE_KEY.APPLICATION,
  LANGUAGE_KEY.ARCHIVED_VERSION,
  LANGUAGE_KEY.ARE_YOU_SURE,
  LANGUAGE_KEY.AREA,
  LANGUAGE_KEY.ASSIGNMENT_CAN_NOT_BE_UNASSIGNED,
  LANGUAGE_KEY.ASSIGNMENT_PERFORMANCE,
  LANGUAGE_KEY.ASSIGNMENT_REPORT_TITLE,
  LANGUAGE_KEY.ASSIGNMENT_SUBMISSIONS_TITLE,
  LANGUAGE_KEY.ASSIGNMENT_TYPE_DOES_NOT_SUPPORT_PASS_FAIL_GRADING,
  LANGUAGE_KEY.ASSIGNMENT_TYPE_DOES_NOT_SUPPORT_SCORE_GRADING,
  LANGUAGE_KEY.ATTEMPT,
  LANGUAGE_KEY.ATTEMPTS_ALLOWED,
  LANGUAGE_KEY.ATTEMPT_LIMIT,
  LANGUAGE_KEY.ATTEMPT_LIMIT_TOOLTIP_LABEL,
  LANGUAGE_KEY.ATTEMPT_LIMIT_TOOLTIP_MESSAGE_BOLD_WORD,
  LANGUAGE_KEY.AUTHESS_MODAL_MESSAGE,
  LANGUAGE_KEY.AUTOMATICALLY_ADD_AND_DISTRIBUTE_CONTENT_ACROSS_WEEKS,
  LANGUAGE_KEY.AVERAGE_ACTION_SCORE_ON_BEST_ATTEMPT,
  LANGUAGE_KEY.AVERAGE_QUESTION_PERFORMANCE,
  LANGUAGE_KEY.AVERAGE_QUESTIONS_MESSAGE,
  LANGUAGE_KEY.AVERAGE_SCORE,
  LANGUAGE_KEY.BATCH_ACTION_BAR_EDIT_CLOSE,
  LANGUAGE_KEY.BATCH_ACTION_BAR_EDIT_DATES_NO_ITEMS_SELECTED,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_DESELECT_ALL,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_EDIT_DATES,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_MAKE_VISIBLE_NOW,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_MOVE_REORDER,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_REMOVE,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_SELECT_ALL,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_UNASSIGN,
  LANGUAGE_KEY.BOOK_SECTION,
  LANGUAGE_KEY.BULK_ADD,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_AVAILABLE_FROM_COL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_BY_DAYS,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_BY_HOURS,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_BY_MINUTES,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_BY_WEEKS,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_CANCEL_BTN,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_CHANGE_ALL_DATES_TAB,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_DUE_COL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_GRADING_STARTED_ASSIGNMENT_WARNING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_GRADE_POINTS_STARTED_ASSIGNMENT_WARNING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_NOT_GRADED_GRADE_POINTS_WARNING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_UNPUBLISHED_LESSON_SKIPPED_WARNING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_AVAILABLE_DATE,
  LANGUAGE_KEY.APPLY_TO_ALL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_AVAILABLE_DATE_NO_DATE,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_DUE_DATE,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_DUE_DATE_NO_DATE,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_GRADING_STARTED_ASSIGNMENT_WARNING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_GRADE_POINTS_STARTED_ASSIGNMENT_WARNING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_HEADING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_AVAILABLE_DATE,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_DUE_DATE,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_GRADING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_UNSUPPORTED_ITEM_GRADE_POINTS_WARNING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_DUE_DATE_MODAL_DESCRIPTION,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_GRADING_MODAL_DESCRIPTION,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_GRADE_POINTS_MODAL_DESCRIPTION,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EXTEND_ALL_DATES_TAB,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_HEADER,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_INCLUDE_AVAILABLE_COL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_INCLUDE_DUE_COL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_PUSH_AVAILABILITY_DATES,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_PUSH_DUE_DATES,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_RESOURCE_NAME_COL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_RESOURCE_TYPE_COL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_SHIFT_DATES_TAB,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_SUBMIT_BTN,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_SUBMIT_TOAST_ERROR,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_TEACHING_RESOURCE_WARNING,
  LANGUAGE_KEY.BULK_SELECT,
  LANGUAGE_KEY.BUILD_COURSE_WITH_DESIRED_CONTENT,
  LANGUAGE_KEY.BUTTON_ADD,
  LANGUAGE_KEY.BUTTON_ADD_A_FOLDER,
  LANGUAGE_KEY.BUTTON_ADD_MORE_RESOURCES,
  LANGUAGE_KEY.CONFIRM,
  LANGUAGE_KEY.CANCEL,
  LANGUAGE_KEY.CANCEL_AND_RETURN_TO_PREVIOUS_PAGE,
  LANGUAGE_KEY.CANNOT_BE_UNASSIGNED,
  LANGUAGE_KEY.CASE_STUDY,
  LANGUAGE_KEY.CATALOG,
  LANGUAGE_KEY.CATALOG_ITEM_STATUS_VIEW_LESS_BTN,
  LANGUAGE_KEY.CHANGE_COURSE,
  LANGUAGE_KEY.CLASS_AVERAGE_ON_ALL_SUBMISSIONS,
  LANGUAGE_KEY.CLASS_AVERAGE_ON_VIDEO_COMPLETION_FOR_ALL_VIEWS,
  LANGUAGE_KEY.CLEAR_FILTERS,
  LANGUAGE_KEY.CLEAR_SEARCH,
  LANGUAGE_KEY.CLICK_HERE,
  LANGUAGE_KEY.COLLAPSE_ALL_FOLDERS,
  LANGUAGE_KEY.COMING_SOON,
  LANGUAGE_KEY.COMPLETE_STUDENTS_TITLE,
  LANGUAGE_KEY.COMPLETED,
  LANGUAGE_KEY.COMPLETED_STUDENTS,
  LANGUAGE_KEY.CONFIRM_ACTION_ON_HIDDEN_SYLLABUS,
  LANGUAGE_KEY.CONFIRM_UNASSIGN_MODAL,
  LANGUAGE_KEY.COPY_COURSE_HAS_CONTENT_MESSAGE,
  LANGUAGE_KEY.COPY_COURSE_NO_CONTENT_MESSAGE,
  LANGUAGE_KEY.COPY_COURSE_REMINDER_MESSAGE_PART_1A,
  LANGUAGE_KEY.COPY_COURSE_REMINDER_MESSAGE_PART_2A,
  LANGUAGE_KEY.COPY_COURSE_REMINDER_MESSAGE_PART_3A,
  LANGUAGE_KEY.COURSE_BUILDER_PREVIEW_DEFAULT_MESSAGE,
  LANGUAGE_KEY.COURSE_BUILDER_WHICH_CONTENT_TYPES,
  LANGUAGE_KEY.COURSE_COPY_UNMAPPED_ITEMS_TITLE,
  LANGUAGE_KEY.COURSE_MIGRATE_UNMAPPED_ITEMS_TITLE,
  LANGUAGE_KEY.COURSE_COPY_WARN_MSG_PART_2A,
  LANGUAGE_KEY.COURSE_END_DATE,
  LANGUAGE_KEY.COURSE_LOCKED_NOTIFICATION,
  LANGUAGE_KEY.COURSE_NAME,
  LANGUAGE_KEY.COURSE_OWNER_LOCKED_NOTIFICATION,
  LANGUAGE_KEY.COURSE_SECTION,
  LANGUAGE_KEY.COURSE_START_DATE,
  LANGUAGE_KEY.CREATE_YOUR_COURSE,
  LANGUAGE_KEY.DATE_CREATED,
  LANGUAGE_KEY.DEFAULT_TAB,
  LANGUAGE_KEY.DISMISS,
  LANGUAGE_KEY.DISMISS_ALL,
  LANGUAGE_KEY.DISPLAY_DATES_TO_FOLDER,
  LANGUAGE_KEY.DO_NOT_ADD_CONTENT_MANUALLY_BUILD_COURSE,
  LANGUAGE_KEY.DRAG_DROP_TOGGLE,
  LANGUAGE_KEY.DUE_BY,
  LANGUAGE_KEY.DUE_DATE,
  LANGUAGE_KEY.DUE_DATE_BEFORE_AVAILABLE_DATE_ERROR_MESSAGE,
  LANGUAGE_KEY.DUE_DATE_IS_REQUIRED_FOR_ALL_EAQ_ASSIGNMENTS,
  LANGUAGE_KEY.DUE_DATE_RESULTS_MESSAGE,
  LANGUAGE_KEY.DUE_DATE_RESULTS_MESSAGE_SIMULATION_LINE1,
  LANGUAGE_KEY.DUE_DATE_RESULTS_MESSAGE_SIMULATION_LINE2,
  LANGUAGE_KEY.DUE_ON_DATE_AT_TIME,
  LANGUAGE_KEY.DURATION,
  LANGUAGE_KEY.E_G_PATIENT_CARE,
  LANGUAGE_KEY.E_G_NAME,
  LANGUAGE_KEY.E_G_SHERPATH_FOR_FUNDAMENTALS,
  LANGUAGE_KEY.EDIT_LESSON_CONTENT,
  LANGUAGE_KEY.EDIT_SETTINGS_NO_ITEMS_SELECTED,
  LANGUAGE_KEY.EMAIL,
  LANGUAGE_KEY.FIRST_NAME,
  LANGUAGE_KEY.LAST_NAME,
  LANGUAGE_KEY.ROLE,
  LANGUAGE_KEY.ENTER_A_NUMBER,
  LANGUAGE_KEY.ENTER_PAGE_NUMBER_AND_OR_PAGE_RANGES_SEPARATED_BY_COMMAS,
  LANGUAGE_KEY.EXPAND_ALL_FOLDERS,
  LANGUAGE_KEY.FAIL,
  LANGUAGE_KEY.FILTER_BY,
  LANGUAGE_KEY.FILTER_BY_APPLICATION,
  LANGUAGE_KEY.FILTER_BY_STATUS,
  LANGUAGE_KEY.FILTER_CONTENT_BY,
  LANGUAGE_KEY.FILTERS_ARE_ON,
  LANGUAGE_KEY.FILL_OUT_THE_FORM_BELOW_TO_BUILD_YOUR_COURSE,
  LANGUAGE_KEY.FIRST_FOLDER_TITLE,
  LANGUAGE_KEY.FOLDER_EDIT_MESSAGE,
  LANGUAGE_KEY.FOLDER_TITLE,
  LANGUAGE_KEY.FOLDER_START_DATE,
  LANGUAGE_KEY.FOLDER_END_DATE,
  LANGUAGE_KEY.GRADE,
  LANGUAGE_KEY.GRADE_TYPE,
  LANGUAGE_KEY.GRADING,
  LANGUAGE_KEY.GRADING_PERFORMANCE_PAGE,
  LANGUAGE_KEY.GRADE_TYPE_CANNOT_BE_CHANGED_ON_STARTED_ASSIGNMENT,
  LANGUAGE_KEY.GRADE_TYPE_AND_GRADE_POINTS_CANNOT_BE_CHANGED_ON_STARTED_ASSIGNMENT,
  LANGUAGE_KEY.GROUP_ACTIVITY_TITLE,
  LANGUAGE_KEY.HESI_FILTER_TOOLTIP,
  LANGUAGE_KEY.HESI_FOCUS_CHAPTERS,
  LANGUAGE_KEY.HOW_DO_YOU_ORGANIZE_YOUR_SYLLABUS,
  LANGUAGE_KEY.HOW_MANY_UNIT_DO_YOU_NEED,
  LANGUAGE_KEY.ICON_NO_PAST_ASSIGNMENTS,
  LANGUAGE_KEY.ICON_NO_UPCOMING_ASSIGNMENTS,
  LANGUAGE_KEY.IMAGE_GALLERY_FETCH_ERROR,
  LANGUAGE_KEY.IMAGE_GALLERY_TITLE,
  LANGUAGE_KEY.UPCOMING_LESSONS,
  LANGUAGE_KEY.UPCOMING_LESSONS_MODAL_MESSAGE,
  LANGUAGE_KEY.INCLUDE,
  LANGUAGE_KEY.IN_ORDER_TO_GET_STARTED_PLEASE_SELECT_HOW_YOU_WOULD_LIKE_TO_ORGANIZE_YOUR_COURSE_RESOURCE,
  LANGUAGE_KEY.IN_PROGRESS,
  LANGUAGE_KEY.IN_PROGRESS_OR_COMPLETED_GRADED_SKIPPED,
  LANGUAGE_KEY.INCOMPLETE_STUDENTS_TITLE,
  LANGUAGE_KEY.INDICATES_REQUIRED_FIELD,
  LANGUAGE_KEY.INFORMATION_TOOLTIP,
  LANGUAGE_KEY.INVALID_GRADE_POINTS,
  LANGUAGE_KEY.INVALID_PAGE_RANGE_ERROR,
  LANGUAGE_KEY.LAST_DATE_WATCHED,
  LANGUAGE_KEY.LATEST_DATE_WATCHED,
  LANGUAGE_KEY.LATE,
  LANGUAGE_KEY.LIMITED,
  LANGUAGE_KEY.LATEST_ATTEMPT_SCORE_TITLE,
  LANGUAGE_KEY.LATEST_SUBMISSION_TIME,
  LANGUAGE_KEY.LEARNING_DURATION,
  LANGUAGE_KEY.LESSON_EDITOR_ASSESSMENT_QUESTIONS_HEADING,
  LANGUAGE_KEY.LESSON_EDITOR_ASSESSMENT_QUESTIONS_INSTRUCTION,
  LANGUAGE_KEY.LESSON_EDITOR_ASSIGNMENT_DETAILS,
  LANGUAGE_KEY.LESSON_EDITOR_BLANK_LABEL,
  LANGUAGE_KEY.LESSON_EDITOR_CONTENT_LOAD_ERROR,
  LANGUAGE_KEY.LESSON_EDITOR_CONTENT_LOAD_RETRY,
  LANGUAGE_KEY.LESSON_EDITOR_EDIT_ASSIGNMENT_DETAILS,
  LANGUAGE_KEY.LESSON_EDITOR_EDIT_CONTENT_TITLE,
  LANGUAGE_KEY.LESSON_EDITOR_LESSON_TOPICS_HEADING,
  LANGUAGE_KEY.LESSON_EDITOR_LESSON_TOPICS_INSTRUCTION,
  LANGUAGE_KEY.LESSON_EDITOR_LOCKED_BANNER,
  LANGUAGE_KEY.LESSON_EDITOR_SELECT_AT_LEAST_ONE_QUESTION,
  LANGUAGE_KEY.LESSON_EDITOR_SELECT_AT_LEAST_ONE_TOPIC,
  LANGUAGE_KEY.LESSON_EDITOR_TOPIC_PREVIEW_BACK,
  LANGUAGE_KEY.LESSON_EDITOR_TOPIC_PREVIEW_LINK_HINT,
  LANGUAGE_KEY.LESSON_EDITOR_TOPIC_PREVIEW_LOAD_ERROR,
  LANGUAGE_KEY.LESSON_EDITOR_TOPIC_PREVIEW_TITLE,
  LANGUAGE_KEY.LESSON_EDITOR_UNSAVED_CHANGES_BODY,
  LANGUAGE_KEY.LESSON_EDITOR_UNSAVED_CHANGES_CONTINUE_EDITING,
  LANGUAGE_KEY.LESSON_EDITOR_UNSAVED_CHANGES_DISCARD,
  LANGUAGE_KEY.LESSON_EDITOR_UNSAVED_CHANGES_TITLE,
  LANGUAGE_KEY.LETS_BUILD_YOUR_COURSE,
  LANGUAGE_KEY.LOCKED,
  LANGUAGE_KEY.LOCK_COPIED_COURSE,
  LANGUAGE_KEY.MAKE_VISIBLE_NOW_NO_ITEMS_SELECTED,
  LANGUAGE_KEY.MAKE_VISIBLE_NOW_ALREADY_AVAILABLE_WARNING_TOAST,
  LANGUAGE_KEY.MISSED_ACTIONS,
  LANGUAGE_KEY.MOVE_REORDER_ALL_ITEM_CANNOT_BE_SELECTED_TO_BE_MOVED_AT_ONCE,
  LANGUAGE_KEY.MOVE_REORDER_NO_ITEMS_SELECTED,
  LANGUAGE_KEY.MY_BOOKS,
  LANGUAGE_KEY.MY_COURSES,
  LANGUAGE_KEY.NEW_CONTENT,
  LANGUAGE_KEY.NEW_LESSONS,
  LANGUAGE_KEY.NEW_LESSONS_ARE_AVAILABLE,
  LANGUAGE_KEY.NEW_LESSONS_AVAILABLE_NOW,
  LANGUAGE_KEY.NO_ASSIGNMENTS,
  LANGUAGE_KEY.NO_ASSIGNMENTS_STU,
  LANGUAGE_KEY.NO_ASSIGNMENTS_WITHIN_DATE_RANGE,
  LANGUAGE_KEY.NO_ASSIGNMENTS_TO_FILTER_IN_GIVEN_DATE_RANGE,
  LANGUAGE_KEY.NO_DUE_DATE,
  LANGUAGE_KEY.NO_ENROLLMENTS,
  LANGUAGE_KEY.NO_ITEM_TO_DISPLAY,
  LANGUAGE_KEY.NO_SUBMISSIONS,
  LANGUAGE_KEY.NO_SUBMISSIONS_BEFORE_DUE_DATE,
  LANGUAGE_KEY.NOT_AVAILABLE,
  LANGUAGE_KEY.NOT_DUE,
  LANGUAGE_KEY.NOT_GRADED,
  LANGUAGE_KEY.NOT_STARTED,
  LANGUAGE_KEY.NOT_VISIBLE,
  LANGUAGE_KEY.NUMBER_OF_ATTEMPTS,
  LANGUAGE_KEY.NUMBER_OF_ALLOWED_ATTEMPTS,
  LANGUAGE_KEY.NUMBER_OF_ALLOWED_ATTEMPTS_LABEL,
  LANGUAGE_KEY.NUMBER_OF_ALLOWED_ATTEMPTS_MIN_ERROR,
  LANGUAGE_KEY.NUMBER_OF_ALLOWED_ATTEMPTS_MAX_ERROR,
  LANGUAGE_KEY.NUMBER_OF_STUDENTS_WITH_ASSIGNMENTS,
  LANGUAGE_KEY.ONLY_FOLDERS_CAN_BE_DRAGGED_TO_THE_ROOT_LEVEL,
  LANGUAGE_KEY.OPEN_COURSE_SETUP,
  LANGUAGE_KEY.OPEN_EBOOK,
  LANGUAGE_KEY.OSMOSIS_PILOT_SURVEY_PROMPT,
  LANGUAGE_KEY.OVERVIEW,
  LANGUAGE_KEY.ORGANIZE_COURSE_BY,
  LANGUAGE_KEY.PAGE_TITLE,
  LANGUAGE_KEY.PASS,
  LANGUAGE_KEY.PASS_FAIL,
  LANGUAGE_KEY.PAST_ASSIGNMENTS,
  LANGUAGE_KEY.PAST_DUE_ASSIGNMENTS,
  LANGUAGE_KEY.PLACE_CONTENT_INTO_PRODUCT_SPECIFIC_FOLDERS_DISTRIBUTE_ACROSS_WEEKS,
  LANGUAGE_KEY.PERCENT_OF_CLASS_PERFORMED_CORRECTLY,
  LANGUAGE_KEY.PLEASE_NOTE_THAT_UNASSIGNING,
  LANGUAGE_KEY.PLEASE_NOTE_STUDENT_DETAILS,
  LANGUAGE_KEY.PLEASE_SELECT_AT_LEAST_ONE_CHAPTER_AND_PAGE,
  LANGUAGE_KEY.PRODUCT,
  LANGUAGE_KEY.PURCHASE_BINDER_READY_VERSION,
  LANGUAGE_KEY.PURCHASE_HARCOVER_VERSION,
  LANGUAGE_KEY.PURCHASE_PAPERBACK_VERSION,
  LANGUAGE_KEY.PURCHASE_SPIRAL_BOUND_VERSION,
  LANGUAGE_KEY.QUESTION_PREVIEW_MODAL_TITLE,
  LANGUAGE_KEY.QUESTION_PREVIEW_MODAL_TYPE,
  LANGUAGE_KEY.READING_SELECTION,
  LANGUAGE_KEY.RE_ATTEMPT_OPEN,
  LANGUAGE_KEY.RE_ATTEMPTS_OPEN,
  LANGUAGE_KEY.RECORDED_ATTEMPT,
  LANGUAGE_KEY.REMOVE_NO_ITEMS_SELECTED,
  LANGUAGE_KEY.REPORT_CONTENT_ERROR,
  LANGUAGE_KEY.RESET,
  LANGUAGE_KEY.RESOURCE_LIBRARY,
  LANGUAGE_KEY.RESOURCE_TYPE,
  LANGUAGE_KEY.RESULTS_FILTERED,
  LANGUAGE_KEY.SAVE_AND_COMPLETE,
  LANGUAGE_KEY.SAVE_AND_CONTINUE_TO_ADVANCED_SETTINGS,
  LANGUAGE_KEY.SCORE,
  LANGUAGE_KEY.SCORED,
  LANGUAGE_KEY.SCORES,
  LANGUAGE_KEY.SEARCH_BY_KEYWORD_CHAPTER_OR_RESOURCE_TYPE,
  LANGUAGE_KEY.SEARCH_BY_COURSE_NAME_PRODUCT_OR_ISBN,
  LANGUAGE_KEY.SEARCH_BY_FIRST_NAME_LAST_NAME_OR_EMAIL_ADDRESS,
  LANGUAGE_KEY.SEARCH_COURSE_SECTION,
  LANGUAGE_KEY.SEARCH,
  LANGUAGE_KEY.FIND_A_RESOURCE,
  LANGUAGE_KEY.SEARCH_FOR_A_STUDENT,
  LANGUAGE_KEY.SECTION,
  LANGUAGE_KEY.SECTIONS,
  LANGUAGE_KEY.SELECT_A_COURSE_TO_COPY,
  LANGUAGE_KEY.SELECT_ALL,
  LANGUAGE_KEY.SELECT_EXISTING_COURSE_REQUIRED_ERROR,
  LANGUAGE_KEY.SET_AS_DEAFULT_TAB,
  LANGUAGE_KEY.SIM_ACTIONS_TOOLTIP,
  LANGUAGE_KEY.SIMULATION,
  LANGUAGE_KEY.SIMULATION_IS_LOADING,
  LANGUAGE_KEY.SKILL,
  LANGUAGE_KEY.SKILL_ATTEMPT_RESULT_CORRECT_TAB,
  LANGUAGE_KEY.SKILL_ATTEMPT_RESULT_HEADER,
  LANGUAGE_KEY.SKILL_ATTEMPT_RESULT_INCORRECT_TAB,
  LANGUAGE_KEY.START_A_SELF_STUDY_QUIZ,
  LANGUAGE_KEY.START_YOUR_COURSE_BUILDING_BY_PROVIDING_A_NAME_FOR_YOUR_FIRST_FOLDER,
  LANGUAGE_KEY.STATUS,
  LANGUAGE_KEY.STUDENT,
  LANGUAGE_KEY.STUDENT_ENGAGEMENT,
  LANGUAGE_KEY.STUDENT_SCORES_TITLE,
  LANGUAGE_KEY.STUDENTS_WATCHED_THIS_VIDEO,
  LANGUAGE_KEY.SUBMISSION_ATTEMPTS_APPLY_SUCCESS,
  LANGUAGE_KEY.SUBMISSION_ATTEMPTS_LABEL,
  LANGUAGE_KEY.SUBMISSION_ATTEMPTS_NOTE,
  LANGUAGE_KEY.SUBMISSION_ATTEMPTS_SKIPPED_WARNING,
  LANGUAGE_KEY.SUBMISSION_ATTEMPTS_TITLE,
  LANGUAGE_KEY.SUBMISSION_TIME,
  LANGUAGE_KEY.SYSTEM_REQUIREMENT_NOTE,
  LANGUAGE_KEY.THE_FOLDER_IS_EMPTY,
  LANGUAGE_KEY.THE_PAGE_NUMBERS_OUT_OF_SCOPE_ERROR,
  LANGUAGE_KEY.THE_PREVIOUS_CHANGES_YOU_MADE_ON_COURSE_PLAN_AND_THE_ASIGNMENTS_WILL_NOT_BE_PRESERVED,
  LANGUAGE_KEY.THIS_COURSE_INCLUDES,
  LANGUAGE_KEY.THIS_COURSE_INCLUDES_THE_FOLLOWING_PRODUCTS,
  LANGUAGE_KEY.THIS_LESSON_HAS_NOT_RELEASE_YET,
  LANGUAGE_KEY.THIS_TYPICALLY_MATCHES_YOUR_SYLLABUS_STRUCTURE,
  LANGUAGE_KEY.TIME_SPENT,
  LANGUAGE_KEY.TIME_SPENT_ON_LESSON_TOOLTIP,
  LANGUAGE_KEY.TOTAL_TIME_SPENT,
  LANGUAGE_KEY.TIME_SPENT_PERFORMANCE_PAGE,
  LANGUAGE_KEY.TOAST_SUCCESS_ADD_SYLLABUS,
  LANGUAGE_KEY.TOAST_SUCCESS_MOVE_SYLLABUS,
  LANGUAGE_KEY.TOAST_SUCCESS_UPDATE_ASSIGNMENTS,
  LANGUAGE_KEY.TOAST_SUCCESS_UPDATE_SYLLABUS,
  LANGUAGE_KEY.TO_BE_UNASSIGNED,
  LANGUAGE_KEY.TOPICS,
  LANGUAGE_KEY.UNABLE_TO_DROP_EXCEED_LIMIT,
  LANGUAGE_KEY.UNABLE_TO_DROP_INTO_ITS_CHILDREN,
  LANGUAGE_KEY.UNABLE_TO_DROP_ITSELF,
  LANGUAGE_KEY.UNABLE_TO_UNASSIGN_BECAUSE_ALREADY_UNASSIGNED,
  LANGUAGE_KEY.UNABLE_TO_UNASSIGN_BECAUSE_GRADED_STARTED,
  LANGUAGE_KEY.UNASSIGN_NO_ITEMS_SELECTED,
  LANGUAGE_KEY.UNLIMITED,
  LANGUAGE_KEY.UPCOMING_ASSIGNMENTS,
  LANGUAGE_KEY.UPCOMING_TAB_MESSAGE,
  LANGUAGE_KEY.VIEW,
  LANGUAGE_KEY.VIEW_ALL_ATTEMPTS,
  LANGUAGE_KEY.VIEW_ATTEMPT_RESULTS,
  LANGUAGE_KEY.VIEW_DETAILS,
  LANGUAGE_KEY.VIEW_FULLSCREEN,
  LANGUAGE_KEY.VIEW_IMAGE_GALLERY,
  LANGUAGE_KEY.VIEW_NEW_LESSONS,
  LANGUAGE_KEY.VIEW_SYSTEM_REQUIREMENTS,
  LANGUAGE_KEY.VIEW_UPCOMING_LESSONS,
  LANGUAGE_KEY.VISIBLE_ON_DATE_AT_TIME,
  LANGUAGE_KEY.VISIBLE_UPON_RELEASE,
  LANGUAGE_KEY.VIDEO_COMPLETED_RESULTS_MESSAGE,
  LANGUAGE_KEY.VIDEO_COMPLETION,
  LANGUAGE_KEY.VIDEO_COMPLETION_BASED_ON_LATEST_VIEW,
  LANGUAGE_KEY.ESTIMATED_TIME,
  LANGUAGE_KEY.WANT_TO_PROCEED,
  LANGUAGE_KEY.WARNING_MESSAGE_FOR_REMOVE_WHEN_FILTERED,
  LANGUAGE_KEY.WARNING_MESSAGE_FOR_UNABLE_TO_REMOVE_WHEN_ASSIGNMENT_STARTED,
  LANGUAGE_KEY.WARNING_MESSAGE_FOR_UNASSIGN_WHEN_FILTER,
  LANGUAGE_KEY.WARNING_MESSAGE_FOR_UNASSIGN_WHEN_THERE_IS_A_SKIPPED_ITEM,
  LANGUAGE_KEY.WARNING_MESSAGE_FOR_UPCOMING_LESSON,
  LANGUAGE_KEY.WARNING_MESSAGE_FOR_ARCHIVED_ASSIGNMENT_INSTRUCTOR,
  LANGUAGE_KEY.WARNING_MESSAGE_FOR_ARCHIVED_ASSIGNMENT_STUDENT,
  LANGUAGE_KEY.WE_NEED_TO_KNOW_A_LITTLE_MORE_ABOUT_HOW_TO_STRUCTURE_YOUR_COURSE,
  LANGUAGE_KEY.WELCOME_TO_COURSE_BUILDER,
  LANGUAGE_KEY.WELCOME_TO_YOUR_COURSE,
  LANGUAGE_KEY.WELCOME_USER,
  LANGUAGE_KEY.WOULD_YOU_LIKE_US_TO_AUTOMATICALLY_ADD_CONTENT_TO_YOUR_COURSE,
  LANGUAGE_KEY.YOU_CAN_ADD_REMOVE_MOVE_CONTENT_AFTER_YOUR_COURSE_IS_CREATED,
  LANGUAGE_KEY.YOUR_COURSE_PLAN_IS_EMPTY,
  LANGUAGE_KEY.YOUR_FILTERED_RESULT_IS_EMPTY,
  LANGUAGE_KEY.ASSIGNMENT_CONTENT_ID_IS_EMPTY,
  LANGUAGE_KEY.ASSIGNMENT_TITLE_IS_EMPTY,
  LANGUAGE_KEY.INVALID_AVAILABILITY_DATE,
  LANGUAGE_KEY.INVALID_DUE_DATE,
  LANGUAGE_KEY.ENTRY_EXCEEDS_LENGTH_LIMIT,
  LANGUAGE_KEY.VALUE_REQUIRED,
  LANGUAGE_KEY.COURSE_COPY_START_DATE_TOOLTIP,
  LANGUAGE_KEY.COPY_URL,
  LANGUAGE_KEY.COPY_DEEP_LINK_INSTRUCTIONS,
  LANGUAGE_KEY.COPY_DEEP_COPY_SUCCESS_TOAST,
  LANGUAGE_KEY.CLOSE,
  LANGUAGE_KEY.DEEP_LINK_CREATE_WARNING_TOAST_LINE_1,
  LANGUAGE_KEY.DEEP_LINK_CREATE_WARNING_TOAST_LINE_2,
  LANGUAGE_KEY.INVALID_URL_FORMAT,
  LANGUAGE_KEY.INVALID_URL_PROTOCOL,
  LANGUAGE_KEY.OKAY,
  LANGUAGE_KEY.TRANSCRIPT,
  LANGUAGE_KEY.TOGGLE_TRANSCRIPT,
  LANGUAGE_KEY.GRADE_POINTS,
  LANGUAGE_KEY.GRADE_POINTS_PERFORMANCE_PAGE,
  LANGUAGE_KEY.EXTERNAL_LINK_TOOLTIP,
  LANGUAGE_KEY.EXTERNAL_LINK_URL_NOTE,
  LANGUAGE_KEY.LAUNCH_STUDENT_VIEW,
  LANGUAGE_KEY.STUDENT_LAUNCH_WARNING,
  LANGUAGE_KEY.ADD_MANAGE_EAB_BANK_AND_ASSESSMENT,
  LANGUAGE_KEY.ADD_MANAGE_EAB_TEST_BANK_AND_ASSESSMENT,
  LANGUAGE_KEY.UPDATE_NAME,
  LANGUAGE_KEY.UPDATE_NAME_DIRECTION,
  LANGUAGE_KEY.UPDATE_NAME_DIRECTION_2,
  LANGUAGE_KEY.EVOLVE_ACCOUNT,
  LANGUAGE_KEY.ADD_NEW_USER_CAPPED,
  LANGUAGE_KEY.ADD_NEW_USER,
  LANGUAGE_KEY.CHANGES_MADE,
  LANGUAGE_KEY.LMS_NOTE,
  LANGUAGE_KEY.SUBMIT,
  LANGUAGE_KEY.REMOVE,
  LANGUAGE_KEY.REMOVE_USER,
  LANGUAGE_KEY.MAKE_SELECTED_RESOURCES_VISIBLE_NOW,
  LANGUAGE_KEY.CONTINUE_TO_COURSE_PLAN,
  LANGUAGE_KEY.CONTENT_RESOURCES_VISIBLE_MODAL_DESCRIPTION,
  LANGUAGE_KEY.MAKE_RESOURCES_VISIBLE,
  LANGUAGE_KEY.MAKE_RESOURCES_VISIBLE_NOW,
  LANGUAGE_KEY.PREVIEW_COURSE,
  LANGUAGE_KEY.UPDATE_PREVIEW,
  LANGUAGE_KEY.UPDATE_PREVIEW_MESSAGE,
  LANGUAGE_KEY.CLICK_HERE_TO_ASSIGN_TO_COURSE_PLAN,
  LANGUAGE_KEY.SHADOW_HEALTH_BANNER_MSG,
  LANGUAGE_KEY.ARE_YOU_SURE_YOU_WANT_TO_REMOVE_FROM_COURSE,
  LANGUAGE_KEY.REMOVED_FROM_COURSE,
  LANGUAGE_KEY.UNABLE_TO_REMOVE_FROM_COURSE,
  LANGUAGE_KEY.ADDED_TO_COURSE,
  LANGUAGE_KEY.UNABLE_TO_ADD_ITEM_ASSIGNMENT_CREATION_FAILED,
  LANGUAGE_KEY.UNABLE_TO_ADD_TO_COURSE,
  LANGUAGE_KEY.NO_NUMBERS_SPACES_OR_SPECIAL_CHARS_ALLOWED,
  LANGUAGE_KEY.INVALID_EMAIL_ADDRESS,
  LANGUAGE_KEY.ALREADY_ADDED_TO_COURSE,
  LANGUAGE_KEY.IFRAME_WARNING,
  LANGUAGE_KEY.IFRAME_WARNING_MSG_LINE_1,
  LANGUAGE_KEY.IFRAME_WARNING_MSG_LINE_2,
  LANGUAGE_KEY.SHOW_FOLDER_VIEW,
  LANGUAGE_KEY.SHOW_LIST_VIEW,
  LANGUAGE_KEY.RETURN_TO_PERFORMNCE_AND_GRADES,
  LANGUAGE_KEY.EXAM_PREP_RESOURCES,
  LANGUAGE_KEY.SUBMIT_FEEDBACK,
  LANGUAGE_KEY.ASK_SHERPATH_AI,
  LANGUAGE_KEY.SEND_SHERPATH_AI_A_PROMPT,
  LANGUAGE_KEY.PREVIEW,
  LANGUAGE_KEY.BEGIN_QUIZ,
  LANGUAGE_KEY.RESUME_QUIZ,
  LANGUAGE_KEY.START_NEW_QUIZ,
  LANGUAGE_KEY.INTERACTIVE_REVIEW_QUESTIONS,
  LANGUAGE_KEY.RESULTS,
  LANGUAGE_KEY.ASSESSMENT_SCORE,
  LANGUAGE_KEY.ALL_DONE,
  LANGUAGE_KEY.ASSESSMENT_PERFORMANCE_CORRECT_TAB,
  LANGUAGE_KEY.ASSESSMENT_PERFORMANCE_INCORRECT_TAB,
  LANGUAGE_KEY.RATIONALE,
  LANGUAGE_KEY.ALL_COURSES_OVERVIEW,
  LANGUAGE_KEY.ALL_COURSES_OVERVIEW_SUBHEADER,
  LANGUAGE_KEY.NO_UPCOMING_ASSIGNMENTS_IN_THE_SELECTED_TIME_PERIOD,
  LANGUAGE_KEY.BACK_TO_CURRENT_WEEK,
  LANGUAGE_KEY.BACK_TO_TOP,
  LANGUAGE_KEY.APPLY,
  LANGUAGE_KEY.FROM_DATE,
  LANGUAGE_KEY.TO_DATE,
  LANGUAGE_KEY.TO_DATE_BEFORE_FROM_DATE_ERROR_MESSAGE,
  LANGUAGE_KEY.BACK_ARROW_TOOLTIP,
  LANGUAGE_KEY.FORWARD_ARROW_TOOLTIP,
  LANGUAGE_KEY.AI_CHAT_PREVIEW_PLACEHOLDER,
  LANGUAGE_KEY.ALL_COURSES_OVERVIEW_COURSE_FILTER_TOOL_TIP,
  LANGUAGE_KEY.HOW_WOULD_YOU_LIKE_YOUR_FOLDERS_TO_BE_SET_UP,
  LANGUAGE_KEY.VIEW_AS_STUDENT,
  LANGUAGE_KEY.EXIT_STUDENT_VIEW,
  LANGUAGE_KEY.VIEWING_AS_STUDENT_MESSAGE,
  LANGUAGE_KEY.CHOOSE_YOUR_COURSE_BUILDING_METHOD,
  LANGUAGE_KEY.CREATE_A_NEW_COURSE,
  LANGUAGE_KEY.CREATE_A_NEW_COURSE_DESCRIPTION,
  LANGUAGE_KEY.COPY_AN_EXISTING_COURSE,
  LANGUAGE_KEY.COPY_AN_EXISTING_COURSE_DESCRIPTION,
  LANGUAGE_KEY.COPY_A_COURSE,
  LANGUAGE_KEY.CREATE_A_NEW_COURSE_WITH_AI,
  LANGUAGE_KEY.UPLOAD_SYLLABUS,
  LANGUAGE_KEY.AI_ENHANCED_COURSE_BUILDER,
  LANGUAGE_KEY.ELSEVIERS_AI_ENHANCED_COURSE_BUILDER,
  LANGUAGE_KEY.UPLOAD_YOUR_SYLLABUS_HEAD_START,
  LANGUAGE_KEY.ELSEVIER_DOES_NOT_SAVE,
  LANGUAGE_KEY.DROP_YOUR_SYLLABUS,
  LANGUAGE_KEY.CLICK_TO_BROWSE,
  LANGUAGE_KEY.MAX_FILE_SIZE,
  LANGUAGE_KEY.SUPPORTS_PDF_DOCX,
  LANGUAGE_KEY.SUCCESS_YOUR_SYLLABUS_HAS,
  LANGUAGE_KEY.PASTE,
  LANGUAGE_KEY.PASTE_TEXT_FROM_SYLLABUS_DIRECTLY,
  LANGUAGE_KEY.PASTE_COURSE_DETAILS,
  LANGUAGE_KEY.PASTE_YOUR_COURSE_DETAILS,
  LANGUAGE_KEY.PASTE_YOUR_SYLLABUS_HERE,
  LANGUAGE_KEY.PASTE_SYLLABUS_DESCRIPTION,
  LANGUAGE_KEY.COPY_AND_PASTE_SYLLABUS_TEXT,
  LANGUAGE_KEY.SUBMIT_COURSE_DETAILS,
  LANGUAGE_KEY.SYLLABUS_CHARACTER_COUNT,
  LANGUAGE_KEY.SYLLABUS_CHARACTER_LIMIT_EXCEEDED,
  LANGUAGE_KEY.SUCCESS_YOUR_SYLLABUS_RECEIVED,
  LANGUAGE_KEY.SYLLABUS_TEXT_UPLOADED_TITLE,
  LANGUAGE_KEY.SYLLABUS_TEXT_CONFIRMATION_DESCRIPTION,
  LANGUAGE_KEY.SYLLABUS_FILE_CONFIRMATION_DESCRIPTION,
  LANGUAGE_KEY.SYLLABUS_TEXT_CONFIRMATION_PRODUCTS,
  LANGUAGE_KEY.SCANNING_YOUR_SYLLABUS_FOR_SECURITY,
  LANGUAGE_KEY.SCANNING_YOUR_FILE_FOR_SECURITY,
  LANGUAGE_KEY.REVIEWING_YOUR_SYLLABUS,
  LANGUAGE_KEY.EXTRACTING_YOUR_COURSE_STRUCTURE,
  LANGUAGE_KEY.MATCHING_RESOURCES_TO_YOUR_TOPICS,
  LANGUAGE_KEY.PREPARING_YOUR_COURSE_PREVIEW,
  LANGUAGE_KEY.YOUR_PROGRESS_WILL_BE_LOST,
  LANGUAGE_KEY.PASTE_SYLLABUS_BACK_WARNING,
  LANGUAGE_KEY.PASTE_SYLLABUS_REFRESH_WARNING,
  LANGUAGE_KEY.I_UNDERSTAND,
  LANGUAGE_KEY.AI_LOOK_FOR,
  LANGUAGE_KEY.COURSE_STRUCTURE_WEEKLY_TOPICS,
  LANGUAGE_KEY.STRUCTURE_WEEKLY_TOPICS,
  LANGUAGE_KEY.LEARNING_OBJECTIVES_OUTCOMES,
  LANGUAGE_KEY.ASSESSMENT_SCHEDULE_TYPES,
  LANGUAGE_KEY.REQUIRED_READINGS_RESOURCES,
  LANGUAGE_KEY.CLINICAL_LAB_REQUIREMENTS,
  LANGUAGE_KEY.NCLEX_QSEN_ALIGNMENT,
  LANGUAGE_KEY.OR,
  LANGUAGE_KEY.DROP_FILE,
  LANGUAGE_KEY.SUCCESS_YOUR_FILE_HAS,
  LANGUAGE_KEY.SYLLABUS_CONFIRMATION_TITLE,
  LANGUAGE_KEY.SYLLABUS_BUILDING_TITLE,
  LANGUAGE_KEY.YOUR_SYLLABUS,
  LANGUAGE_KEY.REMOVE_FILE,
  LANGUAGE_KEY.REMOVE_SYLLABUS,
  LANGUAGE_KEY.SYLLABUS_ANALYSIS_FAILED_GENERIC,
  LANGUAGE_KEY.CANNOT_CONNECT_ERROR,
  LANGUAGE_KEY.FILE_REQUEST_ERROR,
  LANGUAGE_KEY.PASTED_REQUEST_ERROR,
  LANGUAGE_KEY.BACK_AND_EDIT,
  LANGUAGE_KEY.VALIDATION_ERROR_TITLE,
  LANGUAGE_KEY.VALIDATION_ISSUES,
  LANGUAGE_KEY.VALIDATION_SUGGESTIONS,
  LANGUAGE_KEY.PREVIEW_YOUR_COURSE,
  LANGUAGE_KEY.CREATE_OR_EDIT_MESSAGING,
  LANGUAGE_KEY.EDIT_COURSE,
  LANGUAGE_KEY.CREATE_COURSE,
  LANGUAGE_KEY.BACK,
  LANGUAGE_KEY.NO_PREVIEW_AVAILABLE,
  LANGUAGE_KEY.PLEASE,
  LANGUAGE_KEY.EDIT_YOUR_COURSE,
  LANGUAGE_KEY.EDIT_YOUR_COURSE_LC_PERIOD,
  LANGUAGE_KEY.USE_THE_FORM_BELOW,
  LANGUAGE_KEY.UPON_SELECTING_UPDATE_COURSE,
  LANGUAGE_KEY.UPDATE_COURSE,
  LANGUAGE_KEY.BASED_ON_YOUR_SYLLABUS,
  LANGUAGE_KEY.HOW_DOES_IT_WORK,
  LANGUAGE_KEY.ELSEVIERS_AI_ENHANCED,
  LANGUAGE_KEY.UPLOAD_YOUR_SYLLABUS,
  LANGUAGE_KEY.THE_AI_BUILDS_A_COURSE_PREVIEW,
  LANGUAGE_KEY.GENERATE_A_COURSE_PREVIEW,
  LANGUAGE_KEY.REFINE_YOUR_COURSE,
  LANGUAGE_KEY.THE_AI_BUILDS_AN_EDITABLE,
  LANGUAGE_KEY.YOUR_COURSE_IS_ADDED,
  LANGUAGE_KEY.UPLOAD_SYLLABUS_COURSE_CALENDAR,
  LANGUAGE_KEY.FIRST,
  LANGUAGE_KEY.LAST,
  LANGUAGE_KEY.BEST,
  LANGUAGE_KEY.EDITING_HERE_ALLOWS,
  LANGUAGE_KEY.RENAME_FOLDER,
  LANGUAGE_KEY.SELECTED_FOLDER,
  LANGUAGE_KEY.FOLDER_NAME,
  LANGUAGE_KEY.SAVE_FOLDER_NAME,
  LANGUAGE_KEY.REMOVE_FOLDER,
  LANGUAGE_KEY.REMOVE_ITEM,
  LANGUAGE_KEY.ARE_YOU_SURE_YOU_WANT_TO_REMOVE,
  LANGUAGE_KEY.WARNING_ALL_CONTENT,
  LANGUAGE_KEY.YES_REMOVE,
  LANGUAGE_KEY.INCLUDES_COLON,
  LANGUAGE_KEY.CONFIRM_AND_UPLOAD,
  LANGUAGE_KEY.SYLLABUS_PREVIEW_CREATED_TITLE,
  LANGUAGE_KEY.SYLLABUS_PREVIEW_CREATED_DESCRIPTION,
  LANGUAGE_KEY.VIEW_COURSE_PREVIEW,
  LANGUAGE_KEY.STUDENT_STUDY_YOUR_LEARNING,
  LANGUAGE_KEY.STUDENT_STUDY_QBANK,
  LANGUAGE_KEY.STUDENT_STUDY_FOCUS_AREAS,
  LANGUAGE_KEY.STUDENT_STUDY_FOCUS_AREAS_EMPTY_SUBTITLE,
  LANGUAGE_KEY.STUDENT_STUDY_CONCEPTS_TO_FOCUS_ON_FILLED_SUBTITLE,
  LANGUAGE_KEY.STUDENT_STUDY_CONCEPTS_TO_FOCUS_LOAD_ERROR,
  LANGUAGE_KEY.STUDENT_STUDY_LEARN,
  LANGUAGE_KEY.STUDENT_STUDY_QUIZ,
  LANGUAGE_KEY.STUDENT_STUDY_TAKE_YOUR_FIRST_QUIZ,
  LANGUAGE_KEY.STUDENT_STUDY_MY_PROGRESS,
  LANGUAGE_KEY.STUDENT_STUDY_OVERALL_COMPLETION,
  LANGUAGE_KEY.STUDENT_STUDY_LAST_QUIZ_ACTIVITY,
  LANGUAGE_KEY.STUDENT_STUDY_NO_ACTIVITY_FOUND,
  LANGUAGE_KEY.STUDENT_STUDY_QUIZ_HISTORY_EMPTY,
  LANGUAGE_KEY.STUDENT_STUDY_USMLE_STUDY_GUIDE,
  LANGUAGE_KEY.STUDENT_STUDY_USMLE_STUDY_GUIDE_SUBTITLE,
  LANGUAGE_KEY.STUDENT_STUDY_SEARCH_PLACEHOLDER,
  LANGUAGE_KEY.STUDENT_STUDY_PERCENT_CORRECT,
  LANGUAGE_KEY.STUDENT_STUDY_CONCEPTS_TO_FOCUS_ON_SUBTITLE,
  LANGUAGE_KEY.STUDY_TOPICS_SEARCH_PLACEHOLDER,
  LANGUAGE_KEY.STUDY_TOPICS_NO_RESULTS,
  LANGUAGE_KEY.STUDY_TOPICS_LOAD_ERROR,
  LANGUAGE_KEY.STUDENT_STUDY_LOAD_ERROR,
  LANGUAGE_KEY.TEST_PREP_LOAD_ERROR,
  LANGUAGE_KEY.STUDENT_PERFORMANCE_LOAD_ERROR,
  LANGUAGE_KEY.STUDENT_STUDY_PROGRESS_CORRECT,
  LANGUAGE_KEY.STUDENT_STUDY_PROGRESS_INCORRECT,
  LANGUAGE_KEY.STUDENT_STUDY_PROGRESS_UNANSWERED,
  LANGUAGE_KEY.STUDENT_STUDY_PROGRESS_LOAD_ERROR,
  LANGUAGE_KEY.STUDENT_STUDY_RESUME,
  LANGUAGE_KEY.STUDENT_STUDY_REVIEW,
  LANGUAGE_KEY.STUDENT_STUDY_SEE_ALL,
  LANGUAGE_KEY.STUDENT_STUDY_UNTITLED_QUIZ,
  LANGUAGE_KEY.STUDENT_STUDY_LAST_QUIZ_LOAD_ERROR,
  LANGUAGE_KEY.STUDENT_STUDY_OPEN_QUIZ_ERROR,
  LANGUAGE_KEY.RESOURCE_DRAWER_QUESTIONS_ANSWERED,
  LANGUAGE_KEY.RESOURCE_DRAWER_QUESTIONS_CORRECT,
  LANGUAGE_KEY.RESOURCE_DRAWER_QUIZ,
  LANGUAGE_KEY.RESOURCE_DRAWER_NO_RESOURCES,
  LANGUAGE_KEY.RESOURCE_DRAWER_LOAD_ERROR,
  LANGUAGE_KEY.RESOURCE_DRAWER_ALSO_APPEARS_IN,
  LANGUAGE_KEY.RESOURCE_DRAWER_CLOSE,
  LANGUAGE_KEY.RESOURCE_DRAWER_OSMOSIS_VIDEO
];
